export const gameData = [
    {
      "id": "32768",
      "title": "Dino Simulator City Attack",
      "description": "Its 2024 and dinosaurs are not only extinct, but they live peacefully with humans in the city. Well, not quite peacefully! In this realistic dinosaur game, you can choose from different species of these giant animals and you can move, run, destroy, smash, jump, disrupt and literally any action you want in the free 3D world. There are different levels to unlock and different missions to complete in each level. You also have the option to select your favorite dinosaur from the available species.",
      "instructions": "Instructions Take control of your favorite dinosaur and explore the entire map in each level look for the targets before time runs out to complete your missions Controls WASD to move Spacebar to jump Ctr to Run F to interact",
      "url": "https://html5.gamemonetize.com/3jeh3dg86fnn2nlnjjqq2y8dsru7ld3c/",
      "category": "Action",
      "tags": "destroying, Dinosaur, kiz10, run",
      "thumb": "https://img.gamemonetize.com/3jeh3dg86fnn2nlnjjqq2y8dsru7ld3c/512x384.jpg",
      "width": "900",
      "height": "600"
    },
    {
      "id": "32767",
      "title": "Dentist Doctor Game For Kids",
      "description": "Have you ever wanted to be a dentist? Our game can fulfill your desire if you want to be a doctor. In the game, you will play as an oral care doctor who performs different types of dental surgery in a dental clinic. You must perform fillings, cleanings, extractions, stain removal, teeth whitening, and other operations to provide the best oral care for the animals.",
      "instructions": "Mouse click or tap to play ",
      "url": "https://html5.gamemonetize.com/7im5z5sp4512qpsp9x6q0mgp1vbsqz10/",
      "category": "Puzzles",
      "tags": "Animal, Doctor",
      "thumb": "https://img.gamemonetize.com/7im5z5sp4512qpsp9x6q0mgp1vbsqz10/512x384.jpg",
      "width": "1080",
      "height": "1920"
    },
    {
      "id": "32766",
      "title": "Lily Style Dress Up",
      "description": "This is a doll dress-up game for girls. Do you like to dress up dolls? Do you want to make a unique doll for yourself? Our game can fulfill your needs.",
      "instructions": "Mouse click or tap to play ",
      "url": "https://html5.gamemonetize.com/ecl4umbfntze1yt9v5wbov4b89f3nipb/",
      "category": "Hypercasual",
      "tags": "Dress Up, Fun",
      "thumb": "https://img.gamemonetize.com/ecl4umbfntze1yt9v5wbov4b89f3nipb/512x384.jpg",
      "width": "720",
      "height": "1280"
    },
    {
      "id": "32765",
      "title": "Basketball Life 3d",
      "description": "Ready for the wonderful basketball challenge? Basketball Life 3D is a fun and creative sports game that tests your skills and timing! From classic hoop challenges to trick shots, every level is packed with excitement.",
      "instructions": "Mouse click or tap to play ",
      "url": "https://html5.gamemonetize.com/47s9m0brc0yi9uxuiox53uov9hoyy40n/",
      "category": "Hypercasual",
      "tags": "Basketball, Shooter, Sport",
      "thumb": "https://img.gamemonetize.com/47s9m0brc0yi9uxuiox53uov9hoyy40n/512x384.jpg",
      "width": "720",
      "height": "1280"
    },
    {
      "id": "32764",
      "title": "Cute Christmas Animals Jigsaw",
      "description": "Cute Christmas Animals Jigsaw is a fun and festive puzzle game designed for kids! It features three adorable animals dressed in cheerful Christmas costumes: a raccoon in a Santa hat, a bunny with a holiday scarf, and a squirrel holding a gift. Kids can choose from three colorful puzzles, improving their problem-solving skills and hand-eye coordination as they play. The game offers simple controls for young players, vibrant illustrations, and a cheerful holiday soundtrack to set the perfect Christmas mood.",
      "instructions": "use mouse or touch the screen",
      "url": "https://html5.gamemonetize.com/wlw4fy6yuuazzvblnru0uupy7ekhfij4/",
      "category": "Puzzles",
      "tags": "Cartoon, Jigsaw",
      "thumb": "https://img.gamemonetize.com/wlw4fy6yuuazzvblnru0uupy7ekhfij4/512x384.jpg",
      "width": "900",
      "height": "600"
    },
    {
      "id": "32769",
      "title": "Basketball Life 3d",
      "description": "Ready for the wonderful basketball challenge? Basketball Life 3D is a fun and creative sports game that tests your skills and timing! From classic hoop challenges to trick shots, every level is packed with excitement.",
      "instructions": "Mouse click or tap to play ",
      "url": "https://html5.gamemonetize.com/47s9m0brc0yi9uxuiox53uov9hoyy40n/",
      "category": "Hypercasual",
      "tags": "Basketball, Shooter, Sport",
      "thumb": "https://img.gamemonetize.com/47s9m0brc0yi9uxuiox53uov9hoyy40n/512x384.jpg",
      "width": "720",
      "height": "1280"
    },
    {
      "id": "32763",
      "title": "Cowboy Survival Zombie",
      "description": "A game where you are a cowboy in the old west full of zombies. In this game you can sow, harvest, eat, gather resources, build your shelter and shoot the zombies. A completely destructible world. Your goal will be to survive as many days as possible and kill as many zombies.",
      "instructions": " larr A Move left rarr D Move right uarr W Jump Climb ladder darr S Climb down ladder Space bar Shift Pick up item Open door Use well Use bed Left mouse click Shoot Use item Right mouse click Change figure build",
      "url": "https://html5.gamemonetize.com/r0fkcmgbqnoa1v94n4kp2mblrv7ug3ng/",
      "category": "Shooting",
      "tags": "1 Player, 2D, Action, apocalypse, construction, Enemies, Horror, HTML5, Platform, Shoot, Shooter, survival, Violence, Zombie",
      "thumb": "https://img.gamemonetize.com/r0fkcmgbqnoa1v94n4kp2mblrv7ug3ng/512x384.jpg",
      "width": "800",
      "height": "450"
    },
    {
      "id": "32762",
      "title": "Sprunki in Backrooms Christmas Skibidi Terrors",
      "description": "Now Sprunki must escape from Skibidi Toilet in Christmas day. Get all coin to get access to exit. Backroom is so creepy in christmas!",
      "instructions": "WASD to move",
      "url": "https://html5.gamemonetize.com/1dws9womnudxsiqkh056yumex38z3x3v/",
      "category": "Adventure",
      "tags": "Christmas, huggy, Skibidi Toilet, Sprunki",
      "thumb": "https://img.gamemonetize.com/1dws9womnudxsiqkh056yumex38z3x3v/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32761",
      "title": "MR RACER : Car Racing",
      "description": "MR RACER - Car Racing is a thrilling and challenging racing game that will excite you! Race at high speed with stunning supercars and beat the traffic. This game provides a very easy-to-control car movement and is extremely fun to race. Key features: 100 levels in Challenge Mode. Unlimited levels in Chase Mode. Best of race, chase your opponents and show them that you are a Master! Career Race Mode: Beat your rivals and be the legend! 15 Supercars available Upgrade cars to gear up the performance! Customize cars with attractive car paint and wheels Stunning 3D graphics &amp;amp; realistic lighting Different Camera angles",
      "instructions": "W up arrow key accelerate A left arrow key steer left D right arrow key steer right S down arrow key brake H horn",
      "url": "https://html5.gamemonetize.com/y34098moqvr8ueuddbb4vnwxmtorlq4i/",
      "category": "Racing",
      "tags": "3D, Best Games, Car, Police, Race, Racing, Supercars, Unity3D, WebGL",
      "thumb": "https://img.gamemonetize.com/y34098moqvr8ueuddbb4vnwxmtorlq4i/512x384.jpg",
      "width": "960",
      "height": "540"
    },
    {
      "id": "32760",
      "title": "Sprunki Incredibox Memory",
      "description": "This time in the game Sprunki Incredibox Memory you will need to improve your memory. Cards with the image of Sprunki will appear on the playing field. Each character has a double. Remember the location of the heroes. After a few seconds, the cards will turn towards you with the side that will be the same for everyone. You must click on the cards to find paired Sprunks. Please note that you have a limited number of steps, you will find their limit at the top in Sprunki Incredibox Memory.",
      "instructions": "Mouse click or tap to play",
      "url": "https://html5.gamemonetize.com/fnp0ngnsuu5x0bh4lnve42hwx4vc3wcm/",
      "category": "Puzzles",
      "tags": "Fun, Funny, Kids, Memory, Music, Skill",
      "thumb": "https://img.gamemonetize.com/fnp0ngnsuu5x0bh4lnve42hwx4vc3wcm/512x384.jpg",
      "width": "1920",
      "height": "1080"
    },
    {
      "id": "32759",
      "title": "Brick Breaker Ball",
      "description": "Brick Breaker is a classic high-paced game of brick-smashing action. Grab power-ups and extra lives before they fall. Can you set a new high score?",
      "instructions": "Mouse click or tap to play",
      "url": "https://html5.gamemonetize.com/xg9x94wxgkn2jzndhoielaq4b7jvsxap/",
      "category": "Shooting",
      "tags": "Arcade, Ball, Bricks, Shooter",
      "thumb": "https://img.gamemonetize.com/xg9x94wxgkn2jzndhoielaq4b7jvsxap/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32758",
      "title": "Scroll and Spot",
      "description": "Experience the joy of the holidays with Scroll and Spot, a unique Christmas-themed puzzle game! Explore two beautifully crafted images as you scroll to uncover five subtle differences hidden within.The scrolling feature keeps both images perfectly aligned, making it a dynamic and immersive puzzle experience. Challenge your observation skills and celebrate the holiday spirit with every discovery!",
      "instructions": "Drag the screen to scroll tap to spot the differences and find all 5 differences to advance to the next level ",
      "url": "https://html5.gamemonetize.com/8jxfjtyj3zka0yqz6i8qvr04lmcg8hb8/",
      "category": "Puzzles",
      "tags": "Christmas, Clicker, Difference, Holiday, Puzzle, Side Scrolling",
      "thumb": "https://img.gamemonetize.com/8jxfjtyj3zka0yqz6i8qvr04lmcg8hb8/512x384.jpg",
      "width": "600",
      "height": "800"
    },
    {
      "id": "32757",
      "title": "Colorful Assort Game",
      "description": "Colorful Assort is a fun and vibrant puzzle game where you match and sort colorful balls. Test your strategy skills as you tackle various levels and challenges. Perfect for a quick and relaxing brain teaser!",
      "instructions": "Mouse click or tap to play",
      "url": "https://html5.gamemonetize.com/92rgvlnfyvms2w91puiip5hr27x4y3uj/",
      "category": "Puzzles",
      "tags": "Brain, Casual, Matching, Strategy",
      "thumb": "https://img.gamemonetize.com/92rgvlnfyvms2w91puiip5hr27x4y3uj/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32756",
      "title": "Park The Taxi 3",
      "description": "Park The Taxi 3 is a car driving game. Your task is to drive a taxi and park it into marked parking space. Park the taxi quickly to earn score points and unlock various achievements.",
      "instructions": "Desktop Arrow keys or W A S D to drive the car Mobile Use on-screen buttons to drive ",
      "url": "https://html5.gamemonetize.com/03apdilu81bow5i7jv48mq3kno8ahl02/",
      "category": "Racing",
      "tags": "Android, Car, carparking, Cars, Driving, HTML5, iPhone, Mobile, Parking, Taxi",
      "thumb": "https://img.gamemonetize.com/03apdilu81bow5i7jv48mq3kno8ahl02/512x384.jpg",
      "width": "900",
      "height": "506"
    },
    {
      "id": "32755",
      "title": "Santa Dentist",
      "description": "Get ready for a toothy holiday adventure with Santa Dentist! Step into Santas dental clinic and help him and his festive friends achieve sparkling smiles. Clean cavities, fix broken teeth, and apply braces to naughty or nice patients like Rudolph, elves, and even the Grinch! With colorful tools, fun mini-games, and holiday cheer, youll keep Santas smile shining bright for Christmas. Perfect for kids and families, this game combines learning and laughter for hours of fun. Download Santa Dentist and spread smiles this holiday season!",
      "instructions": "Mouse click or tap to play",
      "url": "https://html5.gamemonetize.com/hb6b8tf7j4ot7v6qaia64199f2kvqtgu/",
      "category": "Clicker",
      "tags": "Baby Games, Casual, Doctor, HTML, mapi games, Simulation",
      "thumb": "https://img.gamemonetize.com/hb6b8tf7j4ot7v6qaia64199f2kvqtgu/512x384.jpg",
      "width": "768",
      "height": "1024"
    },
    {
      "id": "32754",
      "title": "Heroic Dash World",
      "description": "This new game brings a whole new world of adventure. In Hero Dash World, youll go on an adventure with a little hero as he explores a fantastical realm in search of the most exciting levels! Play free, brand-new games on kiz10.com every day. The heros adventure begins when he or she turns around and jumps from platform to platform. To purchase heroes, amass as much gems as possible. Following the arrows will show you when to turn, so you can guide the small character down the path. Get the most coins and unlock more characters as you go.",
      "instructions": "Relive as many times as necessary and repeat the levels to improve your score Have fun with this beautiful game Use the mouse or touch the screen to change the direction ",
      "url": "https://html5.gamemonetize.com/pj94bkx8k8tu202htdwf1dc0u1mdgaz5/",
      "category": "Clicker",
      "tags": "Casual, kiz10, Level, run",
      "thumb": "https://img.gamemonetize.com/pj94bkx8k8tu202htdwf1dc0u1mdgaz5/512x384.jpg",
      "width": "700",
      "height": "900"
    },
    {
      "id": "32753",
      "title": "Survev.io",
      "description": "Survev.io Battle Royale is a thrilling multiplayer game where you fight to be the last character standing on a shrinking island. Start with nothing but your fists, scavenge for weapons and supplies, and stay within the safe zone. Choose between solo, duo, or squad modes, and use strategy and skills to outlast up to 50 opponents.",
      "instructions": "Movement W A S D Aim Mouse Melee Shoot Left-Click Change Weapons 1 through 4 or Scroll Wheel Stow Weapons Melee Mode 3 or E Swap to Previous Weapon Q Switch Gun Slots T or drag gun to other slot Reload R Scope Zoom Left-click on Zoo",
      "url": "https://html5.gamemonetize.com/q9xrmuceu30pey8llzop5cr0p1p2fbx9/",
      "category": "Multiplayer",
      "tags": ".io, Battle, Multiplayer, Shoot 'Em Up, Shooter",
      "thumb": "https://img.gamemonetize.com/q9xrmuceu30pey8llzop5cr0p1p2fbx9/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32602",
      "title": "Heli Monsters Giant Hunter",
      "description": "Ready to face the massive challenge? In Heli Monsters - Giant Hunter, you will face crazy monsters and begin an exciting shooting adventure! You will use your gun to aim at the monster and fight them. Your task is to destroy them and keep the city safe! Buy higher-damage guns and bullets with gold. Such as AWM, M200, M24, etc.",
      "instructions": "Mouse click or tap to play ",
      "url": "https://html5.gamemonetize.com/tloh1r8i3pywjg2n3wyemj2uqjlktcnj/",
      "category": "Arcade",
      "tags": "Gun, Shoot, Spiderman",
      "thumb": "https://img.gamemonetize.com/tloh1r8i3pywjg2n3wyemj2uqjlktcnj/512x384.jpg",
      "width": "750",
      "height": "1334"
    },
    {
      "id": "32571",
      "title": "Bus Jam Sort",
      "description": "The passengers are waiting for their bus, sort them out based on their color! Visually, Bus Jam Game is a visual treat, imagine colorful buses, a diverse passengers, and a lively backdrop setting the stage for your bustling triple match puzzle adventure. Smooth animations elevate the fun, making each move a delightful experience in puzzle games.",
      "instructions": "So prepare yourself for the challenge Can you master the sort puzzle shuffle passengers and release VIPs in the on time With its simple yet clever bus match gameplay this game guarantees hours of entertainment for those who love the thrilled puzzle ",
      "url": "https://html5.gamemonetize.com/wlb9vj2y6oazlm6q8vvostlu8w649f71/",
      "category": "Puzzles",
      "tags": "1 Player, bus, puzzleblock, sort",
      "thumb": "https://img.gamemonetize.com/wlb9vj2y6oazlm6q8vvostlu8w649f71/512x384.jpg",
      "width": "720",
      "height": "1280"
    },
    {
      "id": "32573",
      "title": "Coin Sort Puzzle",
      "description": "Play now for free&amp;mdash;fun and addictive grid gameplay. Sort and merge coins to clear the board. Test your skills and earn coins. Fun for all ages! Welcome to the exhilarating world of Coin Sort, where speed, precision, and strategy come together in a captivating arcade-style puzzle game. As a Coin Sorter in a match game, your mission is to efficiently organize an ever-growing flow of coins into their respective lines based on their denominations. Are you ready to put your decision-making skills and reflexes to the test? Embark on a thrilling sorting adventure and unlock new levels.",
      "instructions": "Coin Sort and Merge offers a thrilling blend of strategy reflexes and puzzle-solving that will keep you attracted for hours This addictive game provides endless fun and entertainment Get ready to immerse yourself in the world of coins sorting and me",
      "url": "https://html5.gamemonetize.com/imaqq34l0iw90484l470rs0cfu7pofze/",
      "category": "Puzzles",
      "tags": "1 Player, 2048, Puzzle, sort",
      "thumb": "https://img.gamemonetize.com/imaqq34l0iw90484l470rs0cfu7pofze/512x384.jpg",
      "width": "720",
      "height": "1280"
    },
    {
      "id": "32587",
      "title": "Light Stream",
      "description": "Pass through the laser beam by reflecting in the mirror to unlock the gate. At the beginning we see a boy, who reveals how the door will be unlocked by Laser beam to reach the next level. Now its the players turn to accept the challenge and solve the door unlock process by setting the laser beam to the correct position. Don&amp;rsquo;t forget to collect 3 stars. If you like genres such as physics based games, laser beam games or just want to have a good time then this game is for you. Features of this game: High Quality graphics Game size is minimal Super simple controls Interesting Quests",
      "instructions": "How to play Android Use On-Screen touch to control the mirror direction PC Use Mouse Left Click to control the mirror direction ",
      "url": "https://html5.gamemonetize.com/t2g2zoolw99aaoy8seep0ebtuk56phv9/",
      "category": "Puzzles",
      "tags": "2D, Casual, Puzzle",
      "thumb": "https://img.gamemonetize.com/t2g2zoolw99aaoy8seep0ebtuk56phv9/512x384.jpg",
      "width": "720",
      "height": "1280"
    },
    {
      "id": "32595",
      "title": "Ping Pong Battle Table Tennis",
      "description": "Want to have an intense table tennis battle? In Ping Pong Battle - Table Tennis, you will become a ping pong pro and compete with your opponents in a fierce competition! This game combines realistic paddle manipulation with exciting match simulation.",
      "instructions": "Mouse click or tap to play ",
      "url": "https://html5.gamemonetize.com/80whi1rzhhbrxn1f4le2ll0cf5vx5wv2/",
      "category": "Arcade",
      "tags": "Sport, Tennis",
      "thumb": "https://img.gamemonetize.com/80whi1rzhhbrxn1f4le2ll0cf5vx5wv2/512x384.jpg",
      "width": "750",
      "height": "1334"
    },
    {
      "id": "32606",
      "title": "Among Knights",
      "description": "Among Knights is an Adventure Arcade 2D Game that tells a wonderful story of an ancient war between Knights and mutants. Among Knights comes with easy and enjoyable gameplay in an amazing 2D environment, with several places following the story. the games story tells the destiny of a young Knight who was fated to revenge the death of his father and finds out some truth about the ancident. Dive into the story of Among Knights, with the young knight, and defeat some of those mutants in pursuit of their leaders who called the Giant Mutant! Theres plenty to find, but one misstep and its all over.",
      "instructions": "PC WQD For Movement amp Jump Mouse To Attack and Special attack F for Firing Mobile Virtual Joystick for Movement Touch Keys for Attack Special Attack Jump Fire",
      "url": "https://html5.gamemonetize.com/7rqz6ji1okgid9e6zqt6jq7bc6wt3e2s/",
      "category": "Arcade",
      "tags": "2D, Best Games, Casual, Knight, Sword",
      "thumb": "https://img.gamemonetize.com/7rqz6ji1okgid9e6zqt6jq7bc6wt3e2s/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32607",
      "title": "Percys Froggy Frenzy",
      "description": "Jump into the vibrant world of Percys Froggy Frenzy! Guide Percy, a daring frog, through a non-stop adventure where he shoots bubbles. Move Percy left and right as he auto-fires bouncing shots to pop falling bubbles. Along the way, jump across dynamic platforming levels to gather even more coins, boosting Percy&amp;rsquo;s shooting speed, power, and health. Beware&amp;mdash;if Percy takes hits, maybe you&amp;rsquo;ll need to restart the level. With endless progression and varied challenges, this game is perfect for fans of fast-paced, action-packed platformers!",
      "instructions": "Keys A and D or arrows",
      "url": "https://html5.gamemonetize.com/1ye2ka2gz2m1wsy539bi6q5ev2eaqd96/",
      "category": "Hypercasual",
      "tags": "Bubble, Casual, Collecting, frog, Platform",
      "thumb": "https://img.gamemonetize.com/1ye2ka2gz2m1wsy539bi6q5ev2eaqd96/512x384.jpg",
      "width": "1280",
      "height": "720"
    },
    {
      "id": "32619",
      "title": "Hungry Crab",
      "description": "In &amp;ldquo;Hungry Crab&amp;rdquo; your objective is to guide the candy to the crab&amp;rsquo;s mouth by strategically cutting ropes while collecting the stars. Simply swipe your finger across the screen to cut the ropes to play. The candy will then be released and begin its descent toward the crab. However, you must be careful not to let the candy flow away. Features of this game: High Quality graphics will leave only positive feedback Game size is minimal (but not compromised the graphics) and it is good for your device health Super simple controls make it easy to start playing Interesting quests will not let you get bored while playing the game.",
      "instructions": "How to play Android Use On-Screen touch and cut the rope PC Use mouse Left click and cut the rope ",
      "url": "https://html5.gamemonetize.com/sme8rz5qvjf5if0ss3nbztssufmikaoj/",
      "category": "Puzzles",
      "tags": "2D, Casual, Fun, Puzzle",
      "thumb": "https://img.gamemonetize.com/sme8rz5qvjf5if0ss3nbztssufmikaoj/512x384.jpg",
      "width": "1080",
      "height": "1920"
    },
    {
      "id": "32620",
      "title": "Fidget Trading Card Toy",
      "description": "Fidget Trading Card Toy is a fidget trading game that allows you to feel the fun of collecting toy cards! In the game, you will flip cards against opponents and even use the slap feature to set off a fierce trading duel! Your goal is to collect as many rare cards as possible, increase your card collection, and gain more advantages in trading!",
      "instructions": "Mouse click or tap to play ",
      "url": "https://html5.gamemonetize.com/7zoawxqu9m4lg1d02ew9z3t7bmktj5bw/",
      "category": "Hypercasual",
      "tags": "Battle, Card",
      "thumb": "https://img.gamemonetize.com/7zoawxqu9m4lg1d02ew9z3t7bmktj5bw/512x384.jpg",
      "width": "720",
      "height": "1280"
    },
    {
      "id": "32622",
      "title": "BFFs Golden Hour",
      "description": "Get ready to conquer the fashion world with Fall Aesthetics! Travel the globe alongside our stylish crew and unlock your inner fashionista. Mix and match outfits inspired by the vibrant streets of New York, the golden sunsets of Tuscany, the mesmerizing festivals, the traditional beauty of Japan, and the enchanting charm of Scotland. With endless options for dressing up and a touch of wit and fun, Fall Aesthetics will keep you entertained for hours. Play now and let your fashion sense shine like never before!",
      "instructions": "Use your mouse to play the game on a desktop or tap to play on mobile devices ",
      "url": "https://html5.gamemonetize.com/66m25m8w23jo0y0jrhb5g88188suqpwd/",
      "category": "Girls",
      "tags": "1 Player, Dress Up, Fashion, Girls, html5 games, Princess",
      "thumb": "https://img.gamemonetize.com/66m25m8w23jo0y0jrhb5g88188suqpwd/512x384.jpg",
      "width": "1024",
      "height": "768"
    },
    {
      "id": "32624",
      "title": "Nut And Bolt",
      "description": "Get ready to challenge your mind with this fun and addictive puzzle game! Your goal is to match bolts of the same color to the correct nut. It sounds simple, but each level gets trickier as you go, requiring more focus and strategy to complete. As you progress, the levels become more challenging with different colors of bolts.",
      "instructions": "Your task is to match bolts with the same color and place them into the nuts Each bolt is color-coded and you need to carefully arrange them inside the nuts Once all the same-colored bolts are set you rsquo ll complete the puzzle If you find it diffi",
      "url": "https://html5.gamemonetize.com/2fcl63xms01b6w2jai0osfpkrpykl70l/",
      "category": "Puzzles",
      "tags": ".io Games, Number, Puzzle",
      "thumb": "https://img.gamemonetize.com/2fcl63xms01b6w2jai0osfpkrpykl70l/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32633",
      "title": "Sweet Solve",
      "description": "Collect strawberry to the bucket using your brain This game consists of a challenge to collect strawberries in each level by solving the way to get it. Physics based game where you have to destroy blocks and make the way or progress so that strawberries can be collected easily. Think carefully before taking any steps. Either dropping strawberries or destroying them will be the game over. Don&amp;rsquo;t forget to collect stars. If you like genres such as puzzles, physics based games or just want to have a good time then this game is for you. Features of this game: High Quality graphics Game size is minimal Super simple controls Interesting Quests",
      "instructions": "How to play Android Use On-Screen touch or tap PC Use Mouse Left Click ",
      "url": "https://html5.gamemonetize.com/leiasg9oe4sc50inmnmdp4lg328pc5f5/",
      "category": "Puzzles",
      "tags": "2D, Casual, Fun, Puzzle",
      "thumb": "https://img.gamemonetize.com/leiasg9oe4sc50inmnmdp4lg328pc5f5/512x384.jpg",
      "width": "640",
      "height": "960"
    },
    {
      "id": "32641",
      "title": "Adventure Home",
      "description": "Welcome to Adventure Home: Run Adventure, the ultimate mobile game that will take you on a thrilling journey of running, jumping, and treasure collecting! If you like genres such as adventure, action, rpg, platform, quests or just want to have a good time then this game is for you. Features of this game: High Quality graphics will leave only positive feedback Game size is minimal (but not compromised the graphics) and it is good for your device health Super simple controls make it easy to start playing Interesting quests will not let you get bored while playing the game",
      "instructions": "Android Use On-Screen touch buttons to control the player nbsp PC Left Arrow - To move Left Right Arrow - To move Right Up Arrow - To Jump",
      "url": "https://html5.gamemonetize.com/6mw96kdp3ketqjyafnad8t2099h4z9tv/",
      "category": "Hypercasual",
      "tags": "2D, Adventure, Casual, Platform, survival",
      "thumb": "https://img.gamemonetize.com/6mw96kdp3ketqjyafnad8t2099h4z9tv/512x384.jpg",
      "width": "480",
      "height": "270"
    },
    {
      "id": "32649",
      "title": "Scary House Clown Evil",
      "description": "Scary House Clown Evil is an Exciting Thriller 3D horror game, inspired by all horror films about the best serial killers in their creepy Mansion. You wake up and find yourself trapped inside a scary House with blood and dark feelings, with deadly silence and a dangerous clown murderer whos looking around for his next victim to kill. On Scary House Clown Evil horror game you have to Sneak with stealth and explore the scary Mansion, discover and escape rooms and find Every single key for each Room and watch out for the Creepy Clown killer, whos always so suspicious about an intruders presence Nobody escaped the dark pursuer. Dare you?",
      "instructions": "WSQD For Movement Left Shift To Sprint Mobile Virtual Joystick for Movement Touch Screen to look around",
      "url": "https://html5.gamemonetize.com/44z7cekal1224m2ngzkxkekhgdmn001d/",
      "category": "Adventure",
      "tags": "3D Games, Best Games, Escape, free games for your website, Horror",
      "thumb": "https://img.gamemonetize.com/44z7cekal1224m2ngzkxkekhgdmn001d/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32661",
      "title": "Christmas Sledge Rider 3D",
      "description": "Embark on a thrilling winter adventure with winter sledge adventure, the ultimate christmas game for all ages! Jump onto your sledge and race through stunning, snow landscapes filled with festive cheer. With high-quality graphics that bring the winter wonderland to life, you&amp;rsquo;ll feel the excitement of the season as you sled down icy hills, dodge obstacles, and enjoy endless gameplay. Start playing now and join the fun&amp;mdash;sled your way to victory this holiday season!",
      "instructions": "On desktop Use the A D keys or arrow keys On mobile Hold your finger and slide left-right ",
      "url": "https://html5.gamemonetize.com/aaubvnris6mflicefmtln994mf4d4r7m/",
      "category": "Racing",
      "tags": "Christmas, Race, Racing",
      "thumb": "https://img.gamemonetize.com/aaubvnris6mflicefmtln994mf4d4r7m/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32666",
      "title": "Sprunki PopIt",
      "description": "Sprunki PopIt: The Ultimate Bubble-Popping Adventure! Get ready for hours of bubbly fun with Sprunki PopIt, the free-to-play online game that kids everywhere are going crazy for! It&amp;rsquo;s fast, colorful, and packed with exciting challenges. Your goal? Pop all the bubbles, dodge obstacles, and conquer level after level of pure popping chaos!",
      "instructions": "Mouse to play ",
      "url": "https://html5.gamemonetize.com/wqokz2j4q2iqsmhfgy1ablq82cxpmcvo/",
      "category": "Puzzles",
      "tags": "Bubble, Collecting, Fun, Funny, Girl, HTML5, Hypercasual, Kids",
      "thumb": "https://img.gamemonetize.com/wqokz2j4q2iqsmhfgy1ablq82cxpmcvo/512x384.jpg",
      "width": "480",
      "height": "854"
    },
    {
      "id": "32719",
      "title": "Sprunki Clicker Game",
      "description": "In Sprunki Clicker, youve got 60 seconds to make as many clicks as possible to make a great score. The faster you click, the more loot you uncover! Keep an eye out for special time bonuses that can extend your run and boost your score. How much clicks can you make before times up? Its a simple Spunki thrilling game for the fastest clickers!",
      "instructions": "Mouse click or tap to play",
      "url": "https://html5.gamemonetize.com/4ffxennbgf8psg1sermfk67g3ydqhq0r/",
      "category": "Clicker",
      "tags": "Click, Clicker, Sprunki",
      "thumb": "https://img.gamemonetize.com/4ffxennbgf8psg1sermfk67g3ydqhq0r/512x384.jpg",
      "width": "600",
      "height": "1024"
    },
    {
      "id": "32752",
      "title": "Hoop KIngs",
      "description": "Hoop Kings is a casual puzzle game where players aim to score points by solving basketball-themed challenges. With engaging gameplay, vibrant graphics, and a mix of strategy and fun, it&amp;rsquo;s perfect for quick entertainment or longer play sessions.",
      "instructions": "How to play Keyboard Use the arrow keys to swipe the ball left right up or down Touch Screen Swipe left right up or down to control the basketballs movement ",
      "url": "https://html5.gamemonetize.com/8gjrfuo4objslb0okt96n8qo41flqrpj/",
      "category": "Puzzles",
      "tags": "Arcade, Basketball, Puzzle",
      "thumb": "https://img.gamemonetize.com/8gjrfuo4objslb0okt96n8qo41flqrpj/512x384.jpg",
      "width": "4600",
      "height": "2000"
    },
    {
      "id": "32751",
      "title": "Connect the Images",
      "description": "In Connect Image, players are challenged to complete fragmented pictures by matching pieces to their corresponding shaded outlines. The objective is simple but engaging: arrange various parts of an image onto the shaded areas, gradually revealing the full picture as you progress. Each puzzle features distinct sections that need to be carefully connected, testing both your visual perception and problem-solving skills. As you place the image parts in the right spots, the incomplete image slowly transforms into a complete and vivid picture, offering a satisfying sense of accomplishment. The difficulty increases with each level, introducing more complex images and intricate pieces, providing a fun and rewarding experience for players of all skill levels. Whether youre looking to relax or challenge your mind, Connect Image offers an addictive puzzle experience that will keep you hooked for hours!",
      "instructions": "Slide the images at the right position to play this game ",
      "url": "https://html5.gamemonetize.com/wigmwb0qrjycip6o6p7of5984t77ydql/",
      "category": "Puzzles",
      "tags": "Kids, Matching, Puzzle",
      "thumb": "https://img.gamemonetize.com/wigmwb0qrjycip6o6p7of5984t77ydql/512x384.jpg",
      "width": "720",
      "height": "1280"
    },
    {
      "id": "32750",
      "title": "Checkmate Clash",
      "description": "Checkmate Clash is the ultimate online chess experience where strategy meets competition! Outsmart opponent in thrilling matches and show off your tactical brilliance. Whether youre a chess master or a beginner, this game offers exciting challenges to sharpen your skills. Plan your moves, dominate the board, and deliver the perfect checkmate. Are you ready to claim victory? The battle for the crown begins now!",
      "instructions": "Mouse to play ",
      "url": "https://html5.gamemonetize.com/0e8bl4kywmf7kikoysg3y06o0ymk0gi2/",
      "category": "Puzzles",
      "tags": "Arcade, Board, Boys, Brain, Classic, Hypercasual, School, Skill",
      "thumb": "https://img.gamemonetize.com/0e8bl4kywmf7kikoysg3y06o0ymk0gi2/512x384.jpg",
      "width": "468",
      "height": "1366"
    },
    {
      "id": "32749",
      "title": "Bee keeper",
      "description": "In Beekeeper, begin an exciting adventure in the world of bee farming! This fun simulation game lets you become a beekeeping expert. You need to collect honey and sell it to traders. After you get gold you can upgrade scythe damage and bottle capacity.",
      "instructions": "Mouse click or tap to play ",
      "url": "https://html5.gamemonetize.com/l9ysbr2ma4jmf0y0ozewsaucx4d187am/",
      "category": "Arcade",
      "tags": "Farm, Simulation",
      "thumb": "https://img.gamemonetize.com/l9ysbr2ma4jmf0y0ozewsaucx4d187am/512x384.jpg",
      "width": "750",
      "height": "1334"
    },
    {
      "id": "32768",
      "title": "Dino Simulator City Attack",
      "description": "Its 2024 and dinosaurs are not only extinct, but they live peacefully with humans in the city. Well, not quite peacefully! In this realistic dinosaur game, you can choose from different species of these giant animals and you can move, run, destroy, smash, jump, disrupt and literally any action you want in the free 3D world. There are different levels to unlock and different missions to complete in each level. You also have the option to select your favorite dinosaur from the available species.",
      "instructions": "Instructions Take control of your favorite dinosaur and explore the entire map in each level look for the targets before time runs out to complete your missions Controls WASD to move Spacebar to jump Ctr to Run F to interact",
      "url": "https://html5.gamemonetize.com/3jeh3dg86fnn2nlnjjqq2y8dsru7ld3c/",
      "category": "Action",
      "tags": "destroying, Dinosaur, kiz10, run",
      "thumb": "https://img.gamemonetize.com/3jeh3dg86fnn2nlnjjqq2y8dsru7ld3c/512x384.jpg",
      "width": "900",
      "height": "600"
    },
    {
      "id": "32638",
      "title": "Cleaner Race",
      "description": "Your opponents are not idle bystanders; they are formidable adversaries hell-bent on thwarting your efforts. They deploy tactics designed to disrupt your rhythm, to throw you off course. Yet, you remain steadfast, adapting to their maneuvers with grace and composure. Web Dev &lt;a href='https://www.kizi10.org/'&gt;https://www.kizi10.org/&lt;/a&gt;",
      "instructions": "Mouse click or tap to play",
      "url": "https://html5.gamemonetize.com/y7pwif6rxy0sn74qsl8cb0o1m3h2y0nt/",
      "category": "Action",
      "tags": "1 Player, Android, Cleaning, Girl, HTML, iPad, iPhone, Kids, Mentolatux, Mobile, Racing",
      "thumb": "https://img.gamemonetize.com/y7pwif6rxy0sn74qsl8cb0o1m3h2y0nt/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32585",
      "title": "Monster truck stunts mega ramps",
      "description": "Experience the adrenaline rush of monster truck stunts on mega ramps. Master gravity-defying jumps, perform daring flips, and conquer challenging obstacles. Showcase your driving skills in high-octane environments designed for ultimate thrill-seekers. Push the limits and dominate the arena with unparalleled stunts and breathtaking maneuvers. Web Dev &lt;a href='https://www.insanegamesonline.com/'&gt;https://www.insanegamesonline.com/&lt;/a&gt;",
      "instructions": "WASD to drive",
      "url": "https://html5.gamemonetize.com/c7ch6q55gha9c8deporwsucmu9xft57q/",
      "category": "Action",
      "tags": "Driving, Mentolatux, monstertruck, Stunts, vehicle",
      "thumb": "https://img.gamemonetize.com/c7ch6q55gha9c8deporwsucmu9xft57q/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32576",
      "title": "Monster Truck Extreme Stunts",
      "description": "Monster Truck Extreme Stunts takes you on an electrifying ride through epic arenas filled with ramps, loops, and daring obstacles. Unleash massive power as you perform jaw-dropping flips, jumps, and tricks. Show off your stunt skills, crush everything in your path, and conquer every extreme course in this high-octane thrill ride! Web Dev &lt;a href='https://www.crazygamesx.com/'&gt;https://www.crazygamesx.com/&lt;/a&gt;",
      "instructions": "WASD to drive your monster truck",
      "url": "https://html5.gamemonetize.com/v4n2fp1keev6q4w8tih0rcxgo0czdaf8/",
      "category": "Action",
      "tags": "Driving, Kids, Mentolatux, monstertruck, Stunts, unity games, vehicle, WebGL",
      "thumb": "https://img.gamemonetize.com/v4n2fp1keev6q4w8tih0rcxgo0czdaf8/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32569",
      "title": "Cargo Truck Montain Simulator",
      "description": "Cargo Truck Mountain Simulator is an immersive driving game that puts you in the drivers seat of a powerful cargo truck, navigating rugged mountain terrain. Your goal is to transport heavy loads across treacherous roads, steep inclines, and unpredictable weather conditions. With realistic physics, dynamic weather, and challenging landscapes. Web Dev &lt;a href='https://www.funcrazygames.com/'&gt;https://www.funcrazygames.com/&lt;/a&gt;",
      "instructions": "WASD to drive",
      "url": "https://html5.gamemonetize.com/dua7f3lyka1ousc42knq5s53pggj2011/",
      "category": "Action",
      "tags": "Driving, Mentolatux, offroad, Simulator, Truck, trucks, unity games, vehicle, WebGL",
      "thumb": "https://img.gamemonetize.com/dua7f3lyka1ousc42knq5s53pggj2011/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32559",
      "title": "American City Truck Transporting",
      "description": "American City Truck Transporting by BestCrazyGames offers thrilling cargo delivery missions through bustling urban landscapes. Navigate challenging roads, manage various trucks, and experience realistic driving gameplay in this action-packed transport game. Web Dev &lt;a href='https://www.kizi10.org/'&gt;https://www.kizi10.org/&lt;/a&gt;",
      "instructions": "Mouse click or tap to play",
      "url": "https://html5.gamemonetize.com/1nsf9mo5viy91o3xbwdrl6u2yhn5i5o0/",
      "category": "Action",
      "tags": "Driving, Kids, Mentolatux, Simulator, transport, Truck, trucks, Unity3D, vehicle, WebGL",
      "thumb": "https://img.gamemonetize.com/1nsf9mo5viy91o3xbwdrl6u2yhn5i5o0/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32556",
      "title": "Halloween Merge",
      "description": "Merge spooky items, unlock haunted treasures, and celebrate Halloween in this addictive puzzle game. Get ready for a spooky adventure with Halloween Merge: Haunted Puzzle! Dive into a mysterious world filled with Halloween-themed puzzles, spooky items, and eerie challenges that will test your merging skills. Combine haunted artifacts like pumpkins, potions, and ghostly decorations to unlock chilling treasures and transform your haunted mansion. Enjoy a unique merge game experience with Halloween vibes around every corner. Match and merge items to complete levels, reveal secrets, and win daily rewards!",
      "instructions": " Desktop Select and drag items to merge them Click on an item hold down the left mouse button and drag it to the target item to merge Mobile Tap and hold on an item to drag it and drop it onto another to merge ",
      "url": "https://html5.gamemonetize.com/7hd69nd6fkv70epx1d4kwjkx2ymxd3yk/",
      "category": "Puzzles",
      "tags": "Arcade, Best Games, Fun, Halloween, HTML, html5 games, NapTech Games, Puzzle",
      "thumb": "https://img.gamemonetize.com/7hd69nd6fkv70epx1d4kwjkx2ymxd3yk/512x384.jpg",
      "width": "1080",
      "height": "1920"
    },
    {
      "id": "32543",
      "title": "Plane Crash Ragdoll Simulator",
      "description": "As a fearless pilot, your mission is simple: survive a relentless onslaught of rockets targeting your aircraft. But dont be fooled by how easy it looks. Youll feel the rush of adrenaline as you fire rockets at your enemies and fly through dangerous skies! Features: - Many Game Modes: Avoid Rockets, Destroy Enemies and Low Fuel Landing! - Variety of Aircraft: from planes to helicopters - Customizable Skins: unlock various skins for character and aircraft - Realistic Physics &amp;amp; Ragdoll Pilot! - Challenging Levels and Scenarios",
      "instructions": "Aircraft Gas Press the Joystick Aircraft Control Move the Joystick",
      "url": "https://html5.gamemonetize.com/9vz6x0b5dmyk48s8nalz74iupnzh3tyq/",
      "category": "Action",
      "tags": "3D, Action, Air, Aircraft, airplane, Casual, endless, fly, Mobile, Physics, Simulation, Simulator, unity, War",
      "thumb": "https://img.gamemonetize.com/9vz6x0b5dmyk48s8nalz74iupnzh3tyq/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32541",
      "title": "Transport Army vehicle truck driving",
      "description": "Transport vital supplies across rugged terrain, navigating through enemy territory and dangerous landscapes. Complete challenging missions, dodge roadblocks, and upgrade your vehicles armor and speed to overcome obstacles. With realistic controls, customizable trucks, and immersive levels, only the best drivers will lead their convoy to success. Prepare to rev up, strategize, and master the art of military transport in the ultimate army truck driving experience! Web Dev &lt;a href='https://www.insanegamesonline.com/'&gt;https://www.insanegamesonline.com/&lt;/a&gt;",
      "instructions": "WASD to drive the vehicle",
      "url": "https://html5.gamemonetize.com/bi51p6ugftg8ngxfz4x18hw50jskk0fy/",
      "category": "Action",
      "tags": "Army, Driving, Mentolatux, offroad, transport, Truck, trucks, Unity3D, vehicle, WebGL",
      "thumb": "https://img.gamemonetize.com/bi51p6ugftg8ngxfz4x18hw50jskk0fy/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32531",
      "title": "Oil Tank Truck Driving Sim",
      "description": "Oil Tank Truck Driving Sim offers a realistic experience of transporting oil across diverse terrains, featuring authentic physics and traffic scenarios. While it provides an immersive trucking experience, similar games like Oil Tanker Truck Drive and Oil Truck Games: Driving Games also offer comparable gameplay elements. Web Dev &lt;a href='https://www.crazygamesx.com/'&gt;https://www.crazygamesx.com/&lt;/a&gt;",
      "instructions": "WASD to drive",
      "url": "https://html5.gamemonetize.com/9u4hs7eoy90iuifdvh89k5l5h60x0tab/",
      "category": "Action",
      "tags": "Mentolatux, Simulator, transport, Truck, trucks, Unity3D, vehicle, WebGL",
      "thumb": "https://img.gamemonetize.com/9u4hs7eoy90iuifdvh89k5l5h60x0tab/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32519",
      "title": "Truck Driving Construction Transport",
      "description": "The player takes on the role of a skilled truck driver in the construction transport industry. The objective is to navigate various terrains, loading essential construction materials and equipment onto the truck, then driving carefully to the designated construction site. Challenges include maneuvering through traffic, avoiding hazards, and meeting strict delivery times. Web Dev &lt;a href='https://www.crazygamesonline.com/'&gt;https://www.crazygamesonline.com/&lt;/a&gt;",
      "instructions": "WASD to drive your truck",
      "url": "https://html5.gamemonetize.com/fhqjmji6kcucsvwoaplxbtfxoqpya1pz/",
      "category": "Action",
      "tags": "construction, Driving, Kids, Mentolatux, Simulator, Truck, trucks, vehicle",
      "thumb": "https://img.gamemonetize.com/fhqjmji6kcucsvwoaplxbtfxoqpya1pz/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32509",
      "title": "Fire Truck Driving Simulator 2024",
      "description": "In Fire Truck Driving Simulator 2024, players step into the role of a heroic firefighter, driving powerful fire trucks through busy city streets, rural roads, and treacherous mountain paths. The objective is to reach emergency scenes quickly and efficiently, navigating obstacles and traffic while keeping the team safe. Players must master vehicle controls, use sirens strategically to clear paths, and stay calm under pressure. WASD to drive , Web Dev &lt;a href='https://www.bestcrazygames.com/'&gt;https://www.bestcrazygames.com/&lt;/a&gt;",
      "instructions": "WASD to drive",
      "url": "https://html5.gamemonetize.com/ndh1rwjfkejjktdkkwb2bl80tgpg5l03/",
      "category": "Action",
      "tags": "Fire, firefighters, Mentolatux, Simulator, Truck, trucks, vehicle",
      "thumb": "https://img.gamemonetize.com/ndh1rwjfkejjktdkkwb2bl80tgpg5l03/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32386",
      "title": "Animate.Space: Create Animated GIF!",
      "description": "Animate.Space is a game where you can create cartoons, GIFs, and flipbooks directly in your browser. With almost unlimited frames and a variety of drawing tools (paint bucket, eraser, pixel and vector shapes), you can bring your ideas to life through frame-by-frame animation. Easily manage frames (copy, paste, delete), select, move, rotate, resize objects, and undo actions without limits. Save your projects as animated GIFs or share them online, while features like autoframe drawing, ghost preview, and line control help you create smooth, professional-looking animations. No watermarks, no sign-up required &amp;mdash; just pure creativity!",
      "instructions": "Use mouse to draw and use various drawing tools",
      "url": "https://html5.gamemonetize.com/zvluq2l3w4mxywskmoca63u5mm21uvd6/",
      "category": "Action",
      "tags": "Cartoon, Design, Draw, Drawing, Stickman",
      "thumb": "https://img.gamemonetize.com/zvluq2l3w4mxywskmoca63u5mm21uvd6/512x384.jpg",
      "width": "960",
      "height": "600"
    },
    {
      "id": "32345",
      "title": "American Block Sniper Survival Online",
      "description": "In the first-person action game American Block Sniper Online, set in the Minecraft universe, your objective is to clear each level of all adversaries before the timer runs out. You begin each level with only a rifle, but youll discover and equip a wide variety of weaponry as you go. It takes anything from two to five minutes to complete a level, give or take depending on your score. At this point, you should aim to vanquish every enemy that shows up on the map.",
      "instructions": "Instructions Move around the map between buildings collect weapons to eliminate enemies positioned throughout the city W A S D to walk around Mouse to Look around Left Mouse Button to Fire Right Mouse Button to Aim Mouse Wheel To Change Weapons G for G",
      "url": "https://html5.gamemonetize.com/dy2tps9hmgrhuwhk557cdykcx3puevbb/",
      "category": "Action",
      "tags": "kiz10, mineblock, Shooting, Sniper",
      "thumb": "https://img.gamemonetize.com/dy2tps9hmgrhuwhk557cdykcx3puevbb/512x384.jpg",
      "width": "900",
      "height": "600"
    },
    {
      "id": "32287",
      "title": "Warriors Line Up",
      "description": "Immerse yourself in a simple yet thrilling gameplay experience filled with dynamic skills, stunning graphics, and a plethora of challenging enemies. With intuitive mobile controls, you can move swiftly, launch attacks, and deploy powerful skills. Engage in addictive battles that showcase a diverse array of combat techniques, promising an enthralling and captivating adventure for all players.",
      "instructions": "Mouse click or tap to play",
      "url": "https://html5.gamemonetize.com/qxne2dcajybwp6dh2txkiignwfyp569x/",
      "category": "Action",
      "tags": "Click, Mentolatux, Sword, Top Down, Unity3D, War, Warrior, WebGL",
      "thumb": "https://img.gamemonetize.com/qxne2dcajybwp6dh2txkiignwfyp569x/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32237",
      "title": "Fishdom Online",
      "description": "Fishdom Online is a casual game full of fun and creativity. Various gameplay and mini-games bring you a rich gaming experience. Here includes elements such as puzzles, merges, mini-games and collections to make every game challenging and fun. Enjoy relaxing leisure time and improve your skills and strategic abilities through a variety of tasks and challenges.",
      "instructions": "Mouse click or tap to play",
      "url": "https://html5.gamemonetize.com/twy76rh160z329b5luaf0ca9p3a6egbl/",
      "category": "Puzzles",
      "tags": "Arcade, Games",
      "thumb": "https://img.gamemonetize.com/twy76rh160z329b5luaf0ca9p3a6egbl/512x384.jpg",
      "width": "640",
      "height": "1136"
    },
    {
      "id": "32198",
      "title": "Robot Fighting Adventure",
      "description": "Enter Robot Fighting Adventure which is filled with challenges in robot fighting! Here, the battle is the clash of fists and steel. But it is a test of wisdom and strength! As a robot warrior, you will explore the map and unlock more levels.",
      "instructions": "Mouse click or tap to play ",
      "url": "https://html5.gamemonetize.com/riw72brknxjp2r5nx3oh8mh6pm2uqwd2/",
      "category": "Boys",
      "tags": "Battle, Fight, Interactive, Robot, transport",
      "thumb": "https://img.gamemonetize.com/riw72brknxjp2r5nx3oh8mh6pm2uqwd2/512x384.jpg",
      "width": "1334",
      "height": "750"
    },
    {
      "id": "32197",
      "title": "Superhero Transform Change Race",
      "description": "Are you ready to be a superhero and have a racing adventure? In Superhero Transform - Change Race,you should run and transform! In the challenging track, you will incarnate different superheroes. Use their special abilities to avoid obstacles and surpass opponents.",
      "instructions": "Mouse click or tap to play ",
      "url": "https://html5.gamemonetize.com/xq2de54uthny5abw35tq1zxig2lq68k5/",
      "category": "Racing",
      "tags": "Casual, Interactive, running, Superhero",
      "thumb": "https://img.gamemonetize.com/xq2de54uthny5abw35tq1zxig2lq68k5/512x384.jpg",
      "width": "750",
      "height": "1630"
    },
    {
      "id": "32193",
      "title": "Archer Super Hero",
      "description": "action game, where the archer must cross the monster valley, where he encounters many challenges. Collect all the stars in each stage. Archer Hero is a super fun and challenging 2D side-scroller game in the same style as blockbuster games like Super Mario, Donkey Kong and Sonic. The game features 30 levels that will challenge you to beat it. The designs are very colorful and beautiful!",
      "instructions": "Run Right Key D Run Left Key A Attack Key K Jump Key W ",
      "url": "https://html5.gamemonetize.com/2ftxsmhh3aamnm4tjoylww9yehfyv8jk/",
      "category": "Adventure",
      "tags": "1 Player, Action, attack",
      "thumb": "https://img.gamemonetize.com/2ftxsmhh3aamnm4tjoylww9yehfyv8jk/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32166",
      "title": "Car Park Simulator",
      "description": "Welcome to Car Park Simulator, Are you ready to test your driving skills and master the art of parking? Navigate through 72 challenging levels filled with obstacles and narrow spaces...",
      "instructions": "Use the cursor keys to move and steer the car or use the on-screen buttons to navigate the car to the target parking spot ",
      "url": "https://html5.gamemonetize.com/a7gt7aha4f2olhc0riv85xb30e69h23b/",
      "category": "Hypercasual",
      "tags": "Arcade, Car, Parking, Simulation, Skill",
      "thumb": "https://img.gamemonetize.com/a7gt7aha4f2olhc0riv85xb30e69h23b/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32165",
      "title": "Princesses of Quadrobics",
      "description": "Immerse yourself in the world of modern fashion trends with the game &amp;laquo;Princesses of Quadrobics&amp;raquo;! Two beautiful princesses, Eliza and the Little Mermaid, are waiting for your help in creating the perfect images for practicing Quadrobics. First, create a gentle but expressive makeup for each of the girls and put your hair in a comfortable hairstyle. Then choose dresses, jewelry and accessories. But the adventures dont end there! Complete the look by putting masks in the form of adorable animals on the princesses. After all, this is a mandatory part of the Quadrobics trend! Create unique images for your favorite heroines!",
      "instructions": "Depending on the gaming device a computer mouse click or a simple touch on touch screens is used to control it ",
      "url": "https://html5.gamemonetize.com/m98jydx82jjsvo0vhj2vnvtsahxm4981/",
      "category": "Sports",
      "tags": "Animal, Dress Up, Hair, Makeover",
      "thumb": "https://img.gamemonetize.com/m98jydx82jjsvo0vhj2vnvtsahxm4981/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32158",
      "title": "Red And Blue Stickman Spy Puzzles",
      "description": "Want to be an archery hero? Red And Blue Stickman-Spy Puzzles is an exciting and fun action puzzle game. In this game, you will play as a brave blue stickman in this special adventure! In each level, you will face red monsters. To use your agility to evade and defeat enemies. Seize the opportunity to constantly adjust your archery Angle and distance to defeat the red monster.",
      "instructions": "Mouse click or tap to play ",
      "url": "https://html5.gamemonetize.com/h2jx4nmc8znfmowd84tu9ljzdz9tfaf2/",
      "category": "Puzzles",
      "tags": "Adventure, Arcade, Stickman",
      "thumb": "https://img.gamemonetize.com/h2jx4nmc8znfmowd84tu9ljzdz9tfaf2/512x384.jpg",
      "width": "1136",
      "height": "640"
    },
    {
      "id": "32146",
      "title": "Stickman Troll Thief Puzzle",
      "description": "Thief Puzzle is a funny and addictive casual puzzle game. Here you should help a clever stickman with many funny ways to solve puzzles and steal target items. The rich and varied game scene contains many unexpected obstacles and traps, testing your intelligence and logical thinking. Each level of the game is a unique challenge.",
      "instructions": "Mouse click or tap to play",
      "url": "https://html5.gamemonetize.com/136zurog5im5u5grwaf19itso4bn8k6l/",
      "category": "Puzzles",
      "tags": "Stickman",
      "thumb": "https://img.gamemonetize.com/136zurog5im5u5grwaf19itso4bn8k6l/512x384.jpg",
      "width": "750",
      "height": "1334"
    },
    {
      "id": "32125",
      "title": "Logical Ball Escape",
      "description": "Amazing logical mind game with ball and box You have to help that ball to reach the door. Physics based logical thought needs to be solved. Don&amp;rsquo;t let the ball fall, either game will be over. If you like genres such as logical games, mind games or just want to have a good time then this game is for you. Features of this game: High Quality graphics will leave only positive feedback Game size is minimal (but not compromised the graphics) and it is good for your device health Super simple controls make it easy to start playing Interesting quests will not let you get bored while playing the game.",
      "instructions": "How to play Android Use On-Screen touch and tap PC Use Mouse Left Click to tap ",
      "url": "https://html5.gamemonetize.com/5x3c8p5fne5r57bz2olo8fj9usg5fwux/",
      "category": "Puzzles",
      "tags": "2D, Adventure, Casual, Puzzle",
      "thumb": "https://img.gamemonetize.com/5x3c8p5fne5r57bz2olo8fj9usg5fwux/512x384.jpg",
      "width": "1280",
      "height": "720"
    },
    {
      "id": "32186",
      "title": "Monster Trucks Sky Stunts",
      "description": "Monster Trucks Sky Stunts take extreme driving to the next level, as these powerful machines defy gravity with aerial maneuvers. In this high-octane event, monster trucks launch off massive ramps, soaring through the sky before landing with force. Drivers execute jaw-dropping stunts like flips, spins, and mid-air tricks, combining speed and precision. Sky stunts push both trucks and drivers to their limits, thrilling spectators with heart-pounding action and breathtaking jumps. Web Dev &lt;a href='https://www.bestcrazygames.com/'&gt;https://www.bestcrazygames.com/&lt;/a&gt;",
      "instructions": "WASD drive",
      "url": "https://html5.gamemonetize.com/7tyy3jn4nuy6tky2ewyy634azle68jd3/",
      "category": "Racing",
      "tags": "Car, Driving, Mentolatux, monstertruck, Racing, Stunts, Truck, Unity3D, WebGL",
      "thumb": "https://img.gamemonetize.com/7tyy3jn4nuy6tky2ewyy634azle68jd3/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    
    {
      "id": "32217",
      "title": "Truck Simulator Construction",
      "description": "Truck Simulator Construction is a realistic simulation game where players take control of various heavy-duty trucks and machinery to complete challenging construction tasks. From transporting materials to operating cranes and excavators, players must manage time and resources to build structures, roads, and more. With immersive environments and detailed vehicles, experience the life of a construction site worker!",
      "instructions": "WASD - drive",
      "url": "https://html5.gamemonetize.com/u06e6by2a28avhtl0x368c7wv2jnh1tz/",
      "category": "Action",
      "tags": "city, Driving, Mentolatux, Simulation, Truck, Unity3D, WebGL",
      "thumb": "https://img.gamemonetize.com/u06e6by2a28avhtl0x368c7wv2jnh1tz/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32191",
      "title": "Fall Guys 2024",
      "description": "Fall Guys 2024 is a vibrant, offline battle royale where players navigate whimsical obstacle courses and compete in zany minigames. With enhanced customization options, seasonal events, and chaotic fun, it challenges players to outwit and outlast others in a series of playful and hilarious rounds. Experience a colorful frenzy of competition and teamwork in this ever-evolving game. Web Dev &lt;a href='https://www.insanegamesonline.com/'&gt;https://www.insanegamesonline.com/&lt;/a&gt;",
      "instructions": "Use Joystick to walk and button SPACE to jump",
      "url": "https://html5.gamemonetize.com/bzv8wjffafspjcaof9hsu8y37iq4toxc/",
      "category": "Action",
      "tags": "Fall Boys, Fall Guys, Fun, Funny, Kids, Mentolatux, Skill, Unity3D, WebGL",
      "thumb": "https://img.gamemonetize.com/bzv8wjffafspjcaof9hsu8y37iq4toxc/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32179",
      "title": "Noob City The Gangster",
      "description": "You get the chance to live out your wildest dreams as a real-life gangster in the thrilling new action game CraftsMan 3D Gangster, which is reminiscent of Minecraft. Other criminals will be waiting to eliminate you when you go out into the open world. Complete this entertaining 3D action game and confront more dangerous foes at each level.",
      "instructions": "What are the finest Roblox games that can be played without downloading them on Kiz10 com Controls Mouse To LookW A S D To DriveSpace To Hand BreakF To Exit Vehicle",
      "url": "https://html5.gamemonetize.com/jsi5x60oq85umikv4g48xnnqms323v4t/",
      "category": "Action",
      "tags": "Fighting, kiz10, run, Shooter",
      "thumb": "https://img.gamemonetize.com/jsi5x60oq85umikv4g48xnnqms323v4t/512x384.jpg",
      "width": "900",
      "height": "600"
    },
    {
      "id": "32135",
      "title": "Auto Bus Driving 2024",
      "description": "Auto Bus Driving 2024 offers a thrilling and realistic driving experience with the latest buses on diverse city routes. Navigate through challenging traffic, weather conditions, and time-sensitive schedules. With enhanced graphics and dynamic controls, this simulation game allows players to master driving skills, manage passengers, and explore detailed urban landscapes. Web Dev &lt;a href='https://www.kizi10.org/'&gt;https://www.kizi10.org/&lt;/a&gt;",
      "instructions": "WASD to drive",
      "url": "https://html5.gamemonetize.com/ypz3l7ed6h45ovjr0k2bg498umzkx7u7/",
      "category": "Action",
      "tags": "bus, city, Driving, Mentolatux, School, Sim, Unity3D, WebGL",
      "thumb": "https://img.gamemonetize.com/ypz3l7ed6h45ovjr0k2bg498umzkx7u7/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32111",
      "title": "Big wheels",
      "description": "Collect the lying wheels along the way, then the wheels of your bike will increase and you will be able to drive through any obstacles.",
      "instructions": "Mouse click or tap to play",
      "url": "https://html5.gamemonetize.com/7tauq7353xgbawdhttbtpag95t6wdg0v/",
      "category": "Arcade",
      "tags": "3D, Arcade, Bicycle, HTML5",
      "thumb": "https://img.gamemonetize.com/7tauq7353xgbawdhttbtpag95t6wdg0v/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32071",
      "title": "Letter Ball",
      "description": "The addictive adventure game Letter Ball is about fun simple control, mind-blowing puzzles, and a fun brain workout! You control the ball and hit the letters to make words. Your task is to collect the words in the right order, Each level is more difficult than the previous one because you need to make an effort to get the necessary items. Jump, roll and avoid obstacles. Become the best Letter Ball player!",
      "instructions": "Use W A S D or Arrow Keys To Move the Game Use Space to Jump",
      "url": "https://html5.gamemonetize.com/93ttbeq0wocddpfxnjeofu35itvaj7v4/",
      "category": "Puzzles",
      "tags": "Action, Adventure, Ball, Boy, jump, Puzzle",
      "thumb": "https://img.gamemonetize.com/93ttbeq0wocddpfxnjeofu35itvaj7v4/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32069",
      "title": "Frogy Ninja 2D",
      "description": "Step into the Year of the Frog, where the tables turn, and the hunter becomes the hunted! As a once-peaceful frog, youve escaped the ninjas and are now out for revenge. Unleash your kung fu skills in this turn-based action-puzzle game. Navigate hundreds of challenging levels with intuitive swipe controls, enjoy vibrant pixel art, and interact with diverse environments to outsmart enemy ninjas and complete your mission. Web Dev &lt;a href='https://www.crazygamesx.com/'&gt;https://www.crazygamesx.com/&lt;/a&gt;",
      "instructions": "Mouse click or tap to play",
      "url": "https://html5.gamemonetize.com/atmt7anprzlysj20bff1vt7ajavb2457/",
      "category": "Arcade",
      "tags": "2D, Casual, Click, frog, Mentolatux, Ninja, swipe",
      "thumb": "https://img.gamemonetize.com/atmt7anprzlysj20bff1vt7ajavb2457/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32047",
      "title": "Shadow Strike",
      "description": "Kill the enemies to complete the mission, Collect stars to reach the next destination. Explore the enemy world and danger enemies, execute them and more exciting challenges waiting for the player. Be Careful! While exploring the enemy world as those enemies have deadly weapons is very dangerous and deadly traps can harm the player and game will be over. If you like genres such as adventure, action, rpg, platform, quests or just want to have a good time then this game is for you. Features of this game: High Quality graphics. Game size is minimal. Super simple controls. Interesting quests.",
      "instructions": " How to play Android Use On-Screen touch buttons to control the player PC Move Left - Press ldquo A rdquo Move Right - Press ldquo D rdquo Jump - Press ldquo W rdquo Jet-Pack - Press ldquo J rdquo Shoe-Jet - Press ldquo K rdquo Fire - Press ",
      "url": "https://html5.gamemonetize.com/hb4yues17l7d0zk62gmctcm796ky2e0e/",
      "category": "Hypercasual",
      "tags": "2D, Adventure, Casual, Platform",
      "thumb": "https://img.gamemonetize.com/hb4yues17l7d0zk62gmctcm796ky2e0e/512x384.jpg",
      "width": "1280",
      "height": "720"
    },
    {
      "id": "32046",
      "title": "Draw Cute Animals",
      "description": "Fun drawing game for kids! Draw and color cute animals while boosting creativity and learning. Draw Cute Animals Game is an entertaining and educational game designed to spark creativity in young minds. This game allows children to draw and color a wide range of cute animals, from cuddly kittens to playful pandas. With easy-to-follow guides and vibrant color options, kids can create their own masterpieces while learning about different animals. Ideal for preschoolers and toddlers, this game not only enhances artistic skills but also improves hand-eye coordination. Whether your child loves to doodle or is just starting to explore art, Draw Cu",
      "instructions": "Mouse click or tap to play",
      "url": "https://html5.gamemonetize.com/u7zmx2kyw5eehgxrykrsyo52y25vjv4e/",
      "category": "Puzzles",
      "tags": "Baby Games, Best, Best Games, Game, Games, html5 games, Kid, Kids, NapTech Games, Online",
      "thumb": "https://img.gamemonetize.com/u7zmx2kyw5eehgxrykrsyo52y25vjv4e/512x384.jpg",
      "width": "1280",
      "height": "720"
    },
    {
      "id": "32034",
      "title": "Bus School Park Driver",
      "description": "Take the wheel in Bus School Park Driver! Master the art of bus driving with precision parking, smooth navigation, and real-world traffic challenges. Whether you&amp;rsquo;re maneuvering through tight school zones or handling complex parking scenarios, every level tests your skills. Perfect your driving techniques, complete engaging missions, and become the ultimate school bus driver. Web Dev &lt;a href='https://www.coolcrazygames.com/'&gt;https://www.coolcrazygames.com/&lt;/a&gt;",
      "instructions": "Mouse click or tap to play",
      "url": "https://html5.gamemonetize.com/i429yunzarak64517ysvdeki741nrdoc/",
      "category": "Arcade",
      "tags": "Adventure, Arcade, bus, Car, Driving, Unity3D, WebGL",
      "thumb": "https://img.gamemonetize.com/i429yunzarak64517ysvdeki741nrdoc/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32031",
      "title": "The Last Shot",
      "description": "Step into the mystical world of The Last Shot, where your precision and strategy are put to the ultimate test. Guide the mystical orb through intricate levels filled with glowing platforms and obstacles, all set against a beautifully crafted twilight backdrop.",
      "instructions": "Drag your finger to aim the orb towards the platforms Release to shoot the orb and guide it to the green platform Avoid obstacles and use the blue platforms strategically to reach your goal Complete all levels to become the master of The Last Shot The",
      "url": "https://html5.gamemonetize.com/jx55tyrf879uilkgs7zqes0u7muesrfr/",
      "category": "Shooting",
      "tags": "1 Player, 2048, 2D, Air, Android, Best, Best Games, Bubble Shooter",
      "thumb": "https://img.gamemonetize.com/jx55tyrf879uilkgs7zqes0u7muesrfr/512x384.jpg",
      "width": "1080",
      "height": "1920"
    },
    {
      "id": "32023",
      "title": "Jelly Matches",
      "description": "Welcome to the ultimate color-matching challenge! In this engaging puzzle game, your goal is to break a specified number of colored pieces on the board. The game features special pieces with unique properties, including x2 (which doubles the number of broken pieces), -1 (which removes one piece from your total), and shield pieces that offer protection.",
      "instructions": "Drag with mouse or touch to drop a piece and have it fall and be matched",
      "url": "https://html5.gamemonetize.com/45k2hkp92lx338zqlj5m2xr3puexfduw/",
      "category": "Puzzles",
      "tags": "Color, Match 3, Match3, Matching, Math, Physics, Puzzle, puzzleblock",
      "thumb": "https://img.gamemonetize.com/45k2hkp92lx338zqlj5m2xr3puexfduw/512x384.jpg",
      "width": "640",
      "height": "1280"
    },
    {
      "id": "32021",
      "title": "Bridge Wars",
      "description": "Gear up for Bridge Wars, a mobile gaming epic blending creativity and strategy. Immerse in a world where tactical mastery meets artistic flair. Draw patterns, summon stickman defenders in 3 seconds, facing relentless enemy vehicles. Upgrade characters, navigate intense environments, and stop foes from breaching. Embark on a thrilling adventure, showcasing tactical mastery against relentless waves! 1. Unlimited Levels 2. Customizable Characters and Weapons Skins 3. Power up Arsenal with shields and landmines and many more",
      "instructions": "HOW TO PLAY Bridge Wars 1 Draw a pattern to spawn your soldiers within 3 seconds 2 The soldiers spawned will attack the enemy vehicles who will try to cross the bridge full of barricades 3 Visit the shop to upgrade your arsenal such as armor weapons",
      "url": "https://html5.gamemonetize.com/wf6qo75w4eyuvylmnpezdk3ord3ajdlr/",
      "category": "Hypercasual",
      "tags": "Battle, Casual, Hypercasual",
      "thumb": "https://img.gamemonetize.com/wf6qo75w4eyuvylmnpezdk3ord3ajdlr/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32019",
      "title": "Hide And Seek Blue Monster",
      "description": "Enter a world full of mystery and fun. In Hide And Seek: Blue Monster, you will experience a unique hide-and-seek adventure. The game combines casual games with puzzle challenges.",
      "instructions": "Mouse click or tap to play",
      "url": "https://html5.gamemonetize.com/digi5xwq9xlsyolubtfl4ofqyxnc7a02/",
      "category": "Puzzles",
      "tags": "Escape, Hidden, running",
      "thumb": "https://img.gamemonetize.com/digi5xwq9xlsyolubtfl4ofqyxnc7a02/512x384.jpg",
      "width": "640",
      "height": "1334"
    },
    {
      "id": "32010",
      "title": "Pull The Pin Much Money",
      "description": "Pull The Pin - Much Money is a classic math pin puzzle game. In the game, you need to pull out the pin that can make you earn more cash. This game not only tests your thinking ability but also your math skills.",
      "instructions": "Mouse click or tap to play",
      "url": "https://html5.gamemonetize.com/u6y73ibps2wn7w3o4z135ppn4rsrx588/",
      "category": "Puzzles",
      "tags": "Math, Monkey",
      "thumb": "https://img.gamemonetize.com/u6y73ibps2wn7w3o4z135ppn4rsrx588/512x384.jpg",
      "width": "640",
      "height": "1136"
    },
    {
      "id": "31990",
      "title": "Super Doctor Body Examination",
      "description": "Super Doctor Body Examination is an educational game. Do you hate every physical examination, but the physical examination is for your health.",
      "instructions": "Mouse click or tap to play",
      "url": "https://html5.gamemonetize.com/2iwba0rqln0grbzu8wxt3pphl1yrbe9e/",
      "category": "Boys",
      "tags": "Doctor, Educational",
      "thumb": "https://img.gamemonetize.com/2iwba0rqln0grbzu8wxt3pphl1yrbe9e/512x384.jpg",
      "width": "1080",
      "height": "1920"
    },
    {
      "id": "31989",
      "title": "Perfect Piano Magic",
      "description": "Perfect Piano Magic is a fun casual game. If you are a big fan of Piano Magic games, then this is a game you cant afford to miss! The gameplay of this game is extremely similar to Piano Magic.",
      "instructions": "Mouse click or tap to play",
      "url": "https://html5.gamemonetize.com/yxvf7gwdccvrfkoykfngpnmhkjox49gr/",
      "category": "Hypercasual",
      "tags": "1 Player, Music, Shoot",
      "thumb": "https://img.gamemonetize.com/yxvf7gwdccvrfkoykfngpnmhkjox49gr/512x384.jpg",
      "width": "750",
      "height": "1334"
    },
    {
      "id": "31982",
      "title": "Weight Puzzle 3D",
      "description": "Welcome to Weight Puzzle 3D Game! Lift the weights and place them in the correct sections of the road to balance the weights, allowing the player to run and reach the finish line. Lets see if youre good at math and numbers in 3D amazing cool game!",
      "instructions": "Mouse click or tap to play",
      "url": "https://html5.gamemonetize.com/z62h7dsza71b8957l45wgpqq652ttour/",
      "category": "Puzzles",
      "tags": "3D, 3D Games, Physics, Puzzle, Unity3D",
      "thumb": "https://img.gamemonetize.com/z62h7dsza71b8957l45wgpqq652ttour/512x384.jpg",
      "width": "350",
      "height": "600"
    },
    {
      "id": "31971",
      "title": "Uno Online",
      "description": "UNO Online is a strategy card game. In the game, the first player to clear his hand will become the winner. In order to win, you need to guess the deck of cards in your opponents hands and arrange your card order reasonably.",
      "instructions": "Mouse click or tap to play",
      "url": "https://html5.gamemonetize.com/wkxitscgm7t9szdj938hq6bs10ms7rse/",
      "category": "Hypercasual",
      "tags": "Arcade, Card",
      "thumb": "https://img.gamemonetize.com/wkxitscgm7t9szdj938hq6bs10ms7rse/512x384.jpg",
      "width": "1920",
      "height": "1080"
    },
    {
      "id": "31954",
      "title": "Hole Io 2",
      "description": "Hole.io is a super addictive free arcade game. If you were to ask what game is the most popular these days? Then its the black hole devouring game that has exploded in popularity worldwide.",
      "instructions": "Mouse click or tap to play",
      "url": "https://html5.gamemonetize.com/77h4sbaucufl8hc03nna7anwjem7mtop/",
      "category": "Arcade",
      "tags": ".io, Battle",
      "thumb": "https://img.gamemonetize.com/77h4sbaucufl8hc03nna7anwjem7mtop/512x384.jpg",
      "width": "1080",
      "height": "1920"
    },
    {
      "id": "32097",
      "title": "Real Bus Parking Oick and Drop",
      "description": "Bus Parking: Pick and Drop is an engaging driving simulation game that challenges players to master the art of precision parking while providing a smooth ride for passengers. As a skilled bus driver, your task is to navigate busy city streets, pick up passengers from designated stops, and safely drop them off at their destinations. The game features realistic controls and detailed urban environments, making each level more challenging than the last. Perfecting your parking skills is key to advancing through the levels, ensuring timely and accurate drop-offs. Its a must-try for fans of driving and parking simulation games.",
      "instructions": "WASD drive",
      "url": "https://html5.gamemonetize.com/9gtk3fuj8b3956ikmbul44mumh11hftl/",
      "category": "Action",
      "tags": "bus, carparking, city, Driving, Mentolatux, Parking, Sim, Unity3D",
      "thumb": "https://img.gamemonetize.com/9gtk3fuj8b3956ikmbul44mumh11hftl/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32082",
      "title": "TukTuk Rickshaw City Driving Sim",
      "description": "Step into the role of a legendary city tuk-tuk driver in TukTuk Rickshaw City Driving Sim! Complete your tasks on time to unlock exciting new levels in this thrilling rickshaw driving game. Transport passengers from one point to their destination, mastering the art of precise parking to keep them happy.",
      "instructions": "WASD driving",
      "url": "https://html5.gamemonetize.com/jykqi5zuiofupq2hb774wo0nrtplkfua/",
      "category": "Action",
      "tags": "city, Driving, Rickshaw, Sim, TukTuk, vehicle",
      "thumb": "https://img.gamemonetize.com/jykqi5zuiofupq2hb774wo0nrtplkfua/512x384.jpg",
      "width": "800",
      "height": "600"
    },
   
    {
      "id": "32058",
      "title": "Imposter Assassin 3D",
      "description": "Play the entertaining 3D action game Imposter Assassin 3D to transform into a true assassin. It has stealth, shooting, action, enemy guards, and a ton of levels and skins to unlock. Assume charge of an imposter who dares to enter the control base. Numerous enemy troops will be patrolling each level, and they will kill you right away if they discover you.",
      "instructions": "Instructions Move stealthily to attack the soldiers from behind so they dont see you to hit the precise attack at the right time and dont leave a single one alive Use the mouse to move and attack Touch the screen and drag on mobile devices ",
      "url": "https://html5.gamemonetize.com/kjixdc9mw89s3k1rdka4eotbmrgggvkn/",
      "category": "Action",
      "tags": "attack, Fighting, Impostor, Shooter",
      "thumb": "https://img.gamemonetize.com/kjixdc9mw89s3k1rdka4eotbmrgggvkn/512x384.jpg",
      "width": "900",
      "height": "600"
    },
    {
      "id": "32053",
      "title": "Water Slide Adventure",
      "description": "Dive into the ultimate water slide adventure with Extreme Water Slide Adventure! Experience the thrill of speeding down giant slides in this offline swimming pool game. As a super slider, youll navigate crazy twists, turns, and daring stunts that will keep you on the edge of your seat. Packed with excitement and fun, this game offers endless enjoyment for all water slide enthusiasts. Are you ready for the ride of your life?",
      "instructions": "WASD - CONTROL the player",
      "url": "https://html5.gamemonetize.com/9jiw9pzfxozl2lnrio0tb50nnwsmwdxq/",
      "category": "Action",
      "tags": "Adventure, Mentolatux, slide, slider, Unity3D, water, waterslide",
      "thumb": "https://img.gamemonetize.com/9jiw9pzfxozl2lnrio0tb50nnwsmwdxq/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32041",
      "title": "Super Hero Sponge",
      "description": "Join the action-packed adventure with Super Hero Sponge! Embark on an epic journey as the brave sponge hero, battling against formidable enemies and monstrous Big Bosses. Team up with friends, overcome challenging obstacles, and save the day with your heroic skills. With thrilling gameplay and exciting challenges, this adventure is perfect for fans of action and fun. Are you ready to become the ultimate Super Hero Sponge? Web Dev &lt;a href='https://www.kizi10.org/'&gt;https://www.kizi10.org/&lt;/a&gt;",
      "instructions": "Controlls WASD Walk X Attack F Fire SPACE Jump",
      "url": "https://html5.gamemonetize.com/wgoul13b9vne3iifz3cpspkq9hf5dcam/",
      "category": "Action",
      "tags": "2D, Mentolatux, Spongebob, Superhero, Unity3D",
      "thumb": "https://img.gamemonetize.com/wgoul13b9vne3iifz3cpspkq9hf5dcam/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32037",
      "title": "Realistic Lion Hunting Animal 2024",
      "description": "Experience the thrill of the wild in Realistic Lion Hunting Animal 2024! This immersive simulator puts you in the paws of a majestic lion, roaming a vast and realistic forest. Hunt various animals to survive and advance through challenging levels. Explore the dense wilderness, track your prey, and feel the rush of the hunt. Perfect for those seeking adventure and excitement in the animal kingdom. Can you survive the wild?",
      "instructions": "WASD Walk LeftShift Run Mouse Right Stop Run Mouse Left Attack ",
      "url": "https://html5.gamemonetize.com/4xgs7sshdp0wpeqsoztn42pdttjiy5jq/",
      "category": "Action",
      "tags": "Action, Animal, attack, Forest, hunter, lion, Mentolatux, Simulation",
      "thumb": "https://img.gamemonetize.com/4xgs7sshdp0wpeqsoztn42pdttjiy5jq/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "31986",
      "title": "Fish Grow Eating Fish",
      "description": "This adventure game is designed to help you unwind! Dive into the underwater world and strive to become the Ocean King. Begin your journey as a small angelfish and grow by quickly consuming smaller fish. The vast ocean is brimming with surprises, so watch out for larger fish that might bite back. Be patient as you grow stronger, and soon youll be able to take on the bigger fish! Web Dev &lt;a href='https://www.kizi10.org/'&gt;https://www.kizi10.org/&lt;/a&gt;",
      "instructions": "WASD controll the fish SPACE attack",
      "url": "https://html5.gamemonetize.com/jfhu1t3dbwz31jo1ka00z0j043vfjzge/",
      "category": "Action",
      "tags": "Action, Android, eating, Fish, HTML5, iPad, iPhone, Kids, Mentolatux, Skill, WebGL",
      "thumb": "https://img.gamemonetize.com/jfhu1t3dbwz31jo1ka00z0j043vfjzge/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "31976",
      "title": "Silent Assassin 2024",
      "description": "Enter the world of Silent Assassin 2024, where your mission is to eliminate monsters with precision and stealth. Click on the screen as the wheel spins, strategically selecting weapons to throw at the approaching creatures. With each accurate shot, you inch closer to victory. Web Dev &lt;a href='https://www.game-plays.com/'&gt;https://www.game-plays.com/&lt;/a&gt;",
      "instructions": "Mouse click or tap to play",
      "url": "https://html5.gamemonetize.com/bigltd28j37dj9b4n1kz1rufoub9fjyd/",
      "category": "Action",
      "tags": "1 Player, Action, assasin, assassin, Mentolatux, Monster, throwing, Unity3D, weapons, WebGL",
      "thumb": "https://img.gamemonetize.com/bigltd28j37dj9b4n1kz1rufoub9fjyd/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "31949",
      "title": "Fall Fu Panda",
      "description": "Fall Fu Panda is a captivating game where the world revolves, and your character must fall into place. In this game, you&amp;rsquo;ll experience dynamic rotating physics, allowing you to zoom out and view the entire world, track your players position, and follow their every move as they navigate the environment. The goal is to land on objects to score points or defeat enemies. Picture your hero trying to escape from a dungeon or cave, overcoming obstacles in a constantly shifting world. To play, simply tap the left or right side of the screen to rotate the world, making your character fall onto the next block. If they miss and fall off, it&amp;rsquo;s game ove",
      "instructions": "Touch Left Key Left Left Rotate Left Touch Right Key Right Rotate Right ",
      "url": "https://html5.gamemonetize.com/6kx65r64kuooctsuln4qpdyzqqmdfh00/",
      "category": "Puzzles",
      "tags": "Arcade, Fall Boys, Family, HTML, mapi games, Mobile, Panda, Puzzle",
      "thumb": "https://img.gamemonetize.com/6kx65r64kuooctsuln4qpdyzqqmdfh00/512x384.jpg",
      "width": "1280",
      "height": "600"
    },
    {
      "id": "31946",
      "title": "My City Hospital",
      "description": "My City Hospital is a sophisticated digital doll placement game. Have you ever thought about being a doctor or running a hospital to help others?",
      "instructions": "Mouse click or tap to play",
      "url": "https://html5.gamemonetize.com/h1klvtd268m5dea93y1zwuntir8bqay1/",
      "category": "Hypercasual",
      "tags": "Doctor, Simulation",
      "thumb": "https://img.gamemonetize.com/h1klvtd268m5dea93y1zwuntir8bqay1/512x384.jpg",
      "width": "1600",
      "height": "768"
    },
    {
      "id": "31944",
      "title": "Space Survivor Shooting",
      "description": "Space Survivor Shooting is a challenging online game. As an impostor, your task is to plan, move fast, and use your shooting skills to defeat enemies and save allies. Use your intelligence and tactics to kill your opponents quickly.",
      "instructions": "Mouse click or tap to play",
      "url": "https://html5.gamemonetize.com/fgc6kf9h3gtckyse3xsoqx3tubxzg4g5/",
      "category": "Shooting",
      "tags": "Battle, Shoot",
      "thumb": "https://img.gamemonetize.com/fgc6kf9h3gtckyse3xsoqx3tubxzg4g5/512x384.jpg",
      "width": "1136",
      "height": "640"
    },
    {
      "id": "31950",
      "title": "Swipe To Park The Cars",
      "description": "Swipe To Park The Cars is a captivating 2D mobile game that puts your parking skills to the test. In this addictive title, players must skillfully guide a fleet of colorful cars into their designated parking spots using intuitive swipe controls. The challenge lies in the increasing complexity of parking scenarios, from crowded lots to tight spaces, requiring precision and quick thinking. Web Dev &lt;a href='https://www.crazygamesonline.com/'&gt;https://www.crazygamesonline.com/&lt;/a&gt;",
      "instructions": "Mouse click or tap to play",
      "url": "https://html5.gamemonetize.com/0eii7f3a9spn9lw35vo3ovmpur1120tt/",
      "category": "Action",
      "tags": "Android, Cars, Click, HTML5, iPad, iPhone, Mentolatux, Mobile, Mouse, Parking, Skill, Unity3D, WebGL",
      "thumb": "https://img.gamemonetize.com/0eii7f3a9spn9lw35vo3ovmpur1120tt/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "31943",
      "title": "StickMan Defense",
      "description": "Dive into the thrilling world of StickMan Defense, a captivating game where strategy meets action. In this game, players are tasked with defending their base against waves of incoming enemies, using a variety of stickman warriors. Each level challenges your tactical skills, requiring careful placement of troops and timely upgrades. With intuitive controls and engaging graphics, StickMan Defense offers an immersive experience for both casual and hardcore gamers. Web Dev &lt;a href='https://www.insanegamesonline.com/'&gt;https://www.insanegamesonline.com/&lt;/a&gt;",
      "instructions": "Mouse click or tap to play",
      "url": "https://html5.gamemonetize.com/xnm06hp9o6dt48fua7g3jzoddqnkc5fs/",
      "category": "Action",
      "tags": "Android, Click, Defense, HTML5, iPad, iPhone, Mentolatux, Mobile, Stickman, WebGL",
      "thumb": "https://img.gamemonetize.com/xnm06hp9o6dt48fua7g3jzoddqnkc5fs/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "31816",
      "title": "Knife WAR.IO",
      "description": "Enter Knife WAR.IO, where you face off against hordes of opponents in a fierce battle for dominance! Defeat rivals, gather orbs to level up and earn points. As you progress, grow in size and unlock different skins, evolving into a formidable giant in the arena. Strategize your attacks, dodge enemy knives, and rise to the top of this thrilling multiplayer experience! Website Developer &lt;a href='https://www.bestcrazygames.com'&gt;https://www.bestcrazygames.com&lt;/a&gt;",
      "instructions": "Use joystick to move player and A S D F for attacking other players ",
      "url": "https://html5.gamemonetize.com/xvcym1vb1aesda2konvlw79625pnkr6k/",
      "category": "Action",
      "tags": ".io, .io Games, Knight, Mentolatux, Sword, Unity3D, War, WebGL",
      "thumb": "https://img.gamemonetize.com/xvcym1vb1aesda2konvlw79625pnkr6k/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "31801",
      "title": "Craft Theft War",
      "description": "Immerse yourself in the best open-world action-adventure sandbox game, Craft Theft War, inspired by pixel voxel cube craft style online shooting games. Enjoy a vast selection of action-packed games, cool games, and relaxing games, all within a sprawling sandbox environment. This game offers an unparalleled online gaming experience, combining the best elements of open-world adventure, sandbox gameplay, and multiplayer action. Join the fun today and discover why its one of the best online games!",
      "instructions": "Move WASD Aim Mouse Shoot Left Click Jump Space Sprint Shift Reload R ",
      "url": "https://html5.gamemonetize.com/2w7rnj6q5cnt9jt81l0m7s27uqqyqq0f/",
      "category": "Action",
      "tags": "Action, Battle, Bubble Shooter, Multiplayer, Shooting, War",
      "thumb": "https://img.gamemonetize.com/2w7rnj6q5cnt9jt81l0m7s27uqqyqq0f/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "31750",
      "title": "Fall Boys Ulimate Tournament 2024",
      "description": "Welcome to the Fall Boys Ultimate Tournament 2024! Step into a vibrant world filled with exhilarating challenges and fierce competition. Test your skills in a variety of whimsical mini-games that will push your agility and strategy to the limit. Whether youre dodging obstacles, racing against the clock, or working with teammates, aim to outlast and outperform your opponents. Website Developer &lt;a href='https://www.game-plays.com/'&gt;https://www.game-plays.com/&lt;/a&gt;",
      "instructions": "WASD to walk SPACE to jump ",
      "url": "https://html5.gamemonetize.com/nxl2ybhls0ev61j3bf9zzfmlwnjzwe58/",
      "category": "Action",
      "tags": "Best Games, Fall Boys, Fall Guys, Mentolatux, Multiplayer, run, running, unity games, WebGL",
      "thumb": "https://img.gamemonetize.com/nxl2ybhls0ev61j3bf9zzfmlwnjzwe58/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "31749",
      "title": "Escape Wednesday",
      "description": "Break through the monsters to get out of the maze! Many labyrinths will not let you get bored. Show your abilities and you will be the winner. In Wednesday Escape, youll navigate through intricate mazes filled with challenging monsters. Each level presents unique obstacles that test your skills and strategy. Can you outsmart the creatures and find the exit?",
      "instructions": "Move mouse change direction",
      "url": "https://html5.gamemonetize.com/5fw8d2716dxf4t9semyy8pkkfmzpz0jh/",
      "category": "Action",
      "tags": "3D, Escape, Monster, Skill",
      "thumb": "https://img.gamemonetize.com/5fw8d2716dxf4t9semyy8pkkfmzpz0jh/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32768",
      "title": "Dino Simulator City Attack",
      "description": "Its 2024 and dinosaurs are not only extinct, but they live peacefully with humans in the city. Well, not quite peacefully! In this realistic dinosaur game, you can choose from different species of these giant animals and you can move, run, destroy, smash, jump, disrupt and literally any action you want in the free 3D world. There are different levels to unlock and different missions to complete in each level. You also have the option to select your favorite dinosaur from the available species.",
      "instructions": "Instructions Take control of your favorite dinosaur and explore the entire map in each level look for the targets before time runs out to complete your missions Controls WASD to move Spacebar to jump Ctr to Run F to interact",
      "url": "https://html5.gamemonetize.com/3jeh3dg86fnn2nlnjjqq2y8dsru7ld3c/",
      "category": "Action",
      "tags": "destroying, Dinosaur, kiz10, run",
      "thumb": "https://img.gamemonetize.com/3jeh3dg86fnn2nlnjjqq2y8dsru7ld3c/512x384.jpg",
      "width": "900",
      "height": "600"
    },
    {
      "id": "32638",
      "title": "Cleaner Race",
      "description": "Your opponents are not idle bystanders; they are formidable adversaries hell-bent on thwarting your efforts. They deploy tactics designed to disrupt your rhythm, to throw you off course. Yet, you remain steadfast, adapting to their maneuvers with grace and composure. Web Dev &lt;a href='https://www.kizi10.org/'&gt;https://www.kizi10.org/&lt;/a&gt;",
      "instructions": "Mouse click or tap to play",
      "url": "https://html5.gamemonetize.com/y7pwif6rxy0sn74qsl8cb0o1m3h2y0nt/",
      "category": "Action",
      "tags": "1 Player, Android, Cleaning, Girl, HTML, iPad, iPhone, Kids, Mentolatux, Mobile, Racing",
      "thumb": "https://img.gamemonetize.com/y7pwif6rxy0sn74qsl8cb0o1m3h2y0nt/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32585",
      "title": "Monster truck stunts mega ramps",
      "description": "Experience the adrenaline rush of monster truck stunts on mega ramps. Master gravity-defying jumps, perform daring flips, and conquer challenging obstacles. Showcase your driving skills in high-octane environments designed for ultimate thrill-seekers. Push the limits and dominate the arena with unparalleled stunts and breathtaking maneuvers. Web Dev &lt;a href='https://www.insanegamesonline.com/'&gt;https://www.insanegamesonline.com/&lt;/a&gt;",
      "instructions": "WASD to drive",
      "url": "https://html5.gamemonetize.com/c7ch6q55gha9c8deporwsucmu9xft57q/",
      "category": "Action",
      "tags": "Driving, Mentolatux, monstertruck, Stunts, vehicle",
      "thumb": "https://img.gamemonetize.com/c7ch6q55gha9c8deporwsucmu9xft57q/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32576",
      "title": "Monster Truck Extreme Stunts",
      "description": "Monster Truck Extreme Stunts takes you on an electrifying ride through epic arenas filled with ramps, loops, and daring obstacles. Unleash massive power as you perform jaw-dropping flips, jumps, and tricks. Show off your stunt skills, crush everything in your path, and conquer every extreme course in this high-octane thrill ride! Web Dev &lt;a href='https://www.crazygamesx.com/'&gt;https://www.crazygamesx.com/&lt;/a&gt;",
      "instructions": "WASD to drive your monster truck",
      "url": "https://html5.gamemonetize.com/v4n2fp1keev6q4w8tih0rcxgo0czdaf8/",
      "category": "Action",
      "tags": "Driving, Kids, Mentolatux, monstertruck, Stunts, unity games, vehicle, WebGL",
      "thumb": "https://img.gamemonetize.com/v4n2fp1keev6q4w8tih0rcxgo0czdaf8/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32569",
      "title": "Cargo Truck Montain Simulator",
      "description": "Cargo Truck Mountain Simulator is an immersive driving game that puts you in the drivers seat of a powerful cargo truck, navigating rugged mountain terrain. Your goal is to transport heavy loads across treacherous roads, steep inclines, and unpredictable weather conditions. With realistic physics, dynamic weather, and challenging landscapes. Web Dev &lt;a href='https://www.funcrazygames.com/'&gt;https://www.funcrazygames.com/&lt;/a&gt;",
      "instructions": "WASD to drive",
      "url": "https://html5.gamemonetize.com/dua7f3lyka1ousc42knq5s53pggj2011/",
      "category": "Action",
      "tags": "Driving, Mentolatux, offroad, Simulator, Truck, trucks, unity games, vehicle, WebGL",
      "thumb": "https://img.gamemonetize.com/dua7f3lyka1ousc42knq5s53pggj2011/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32559",
      "title": "American City Truck Transporting",
      "description": "American City Truck Transporting by BestCrazyGames offers thrilling cargo delivery missions through bustling urban landscapes. Navigate challenging roads, manage various trucks, and experience realistic driving gameplay in this action-packed transport game. Web Dev &lt;a href='https://www.kizi10.org/'&gt;https://www.kizi10.org/&lt;/a&gt;",
      "instructions": "Mouse click or tap to play",
      "url": "https://html5.gamemonetize.com/1nsf9mo5viy91o3xbwdrl6u2yhn5i5o0/",
      "category": "Action",
      "tags": "Driving, Kids, Mentolatux, Simulator, transport, Truck, trucks, Unity3D, vehicle, WebGL",
      "thumb": "https://img.gamemonetize.com/1nsf9mo5viy91o3xbwdrl6u2yhn5i5o0/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32557",
      "title": "Offroad Driving Truck Transport",
      "description": "Offroad Driving Truck Transport is a thrilling adventure where you navigate rugged terrains, muddy paths, and steep hills. Take control of powerful trucks and transport heavy cargo across challenging off-road landscapes. Master your driving skills, overcome obstacles, and feel the adrenaline rush in this ultimate off-road trucking experience! Web Dev &lt;a href='https://www.crazygamesonline.com/'&gt;https://www.crazygamesonline.com/&lt;/a&gt;",
      "instructions": "Use WASD to controll your truck",
      "url": "https://html5.gamemonetize.com/4bk844pemos2hamkblsoxh01dzxbqm3h/",
      "category": "Action",
      "tags": "Driving, Forest, Kids, Levels, Mentolatux, offroad, Simulator, Truck, trucks, Unity3D, vehicle, WebGL",
      "thumb": "https://img.gamemonetize.com/4bk844pemos2hamkblsoxh01dzxbqm3h/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32539",
      "title": "Basketball Street",
      "description": "Select your favourite player among the 3 available and show your free throws skills! You have one minute and 25 shots to get as many balls as possible into the basket! Striped balls are worth 2 points (instead of 1): concentrate on these special balls for extra points!",
      "instructions": "Use Mouse To Play and Keyboard",
      "url": "https://html5.gamemonetize.com/xvwtddwzkqcwdcahhsrs5btoza8s218i/",
      "category": "Sports",
      "tags": "Arcade, Ball, Ballon, Basketball, Sport",
      "thumb": "https://img.gamemonetize.com/xvwtddwzkqcwdcahhsrs5btoza8s218i/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32529",
      "title": "Emoji Skill Puzzles",
      "description": "Emoji Skill Puzzles is an engaging skill game. Featuring levels constructed entirely with popular emojis. The game offers six distinct puzzle types: link puzzle, memory puzzle, word quiz, related puzzle, shadow puzzle, and crop puzzle. This game is perfect for players who enjoy brain teasers and want to test their problem-solving skills.",
      "instructions": "Mouse click or tap to play",
      "url": "https://html5.gamemonetize.com/grcoj83culvapsxit0uaznoyk1yqf6a0/",
      "category": "Puzzles",
      "tags": "Best, Educational, Fun, Funny, Kids, Matching, Memory, Mobile, Skill",
      "thumb": "https://img.gamemonetize.com/grcoj83culvapsxit0uaznoyk1yqf6a0/512x384.jpg",
      "width": "640",
      "height": "960"
    },
    {
      "id": "32522",
      "title": "Blocks: Move HIT   PRO",
      "description": "Calling all blockheads and those who are called brainy! In Blocks - Move &amp;amp; HIT -PRO youre a hero on a mission, but the path is ever-changing. Navigate a maze of immovable stone blocks that bounce you off course with every bump. Will you hit a 45-degree angle and zip diagonally, or take a full 90-degree turn? Master the rebounds, solve the shifting puzzle, and guide your block to its destined end!",
      "instructions": "Find a path and hit the target to win Challenging ",
      "url": "https://html5.gamemonetize.com/qxlzvjrlxn6clye52zlgntdyjb3ho7w2/",
      "category": "Puzzles",
      "tags": "blocky, Brain, Puzzle, puzzleblock",
      "thumb": "https://img.gamemonetize.com/qxlzvjrlxn6clye52zlgntdyjb3ho7w2/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32506",
      "title": "Cubble on top",
      "description": "cubble on top is a very unique jumping game, you have to jump onto the cliff walls to get to the top and get to the finish, your patience will be tested in this game",
      "instructions": "drag and drop top jump",
      "url": "https://html5.gamemonetize.com/mcu1qexvqwksgoby0bw05y01hqzxlfsu/",
      "category": "Hypercasual",
      "tags": "1 Player, Arcade, jump",
      "thumb": "https://img.gamemonetize.com/mcu1qexvqwksgoby0bw05y01hqzxlfsu/512x384.jpg",
      "width": "1280",
      "height": "720"
    },
    {
      "id": "32502",
      "title": "Point to Merge",
      "description": "Point to Merge is an engaging puzzle game where player must strategically connect numbered blocks to reach the highest value possible. Starting with two blocks numbered 2, the player must point arrows to direct each block towards its match, merging numbers in a sequence (2, 4, 8, 16, etc.). Precision is key&amp;mdash;one wrong move or pointing outside the level restarts the puzzle! With 50 progressively challenging levels, Point to Merge combines sharp thinking and skillful direction to master the art of merging. Can you reach the final number?",
      "instructions": "Point and merge ",
      "url": "https://html5.gamemonetize.com/szb7rfuwk4wnsktxfcpoa49d7r1ircbq/",
      "category": "Hypercasual",
      "tags": "2048, Color, Geometry, Hypercasual",
      "thumb": "https://img.gamemonetize.com/szb7rfuwk4wnsktxfcpoa49d7r1ircbq/512x384.jpg",
      "width": "720",
      "height": "1280"
    },
    {
      "id": "32408",
      "title": "Princesses at Horror School",
      "description": "In this game, you will meet Laura and Frankie, two charming monsters who study at a school for young monsters. Every morning, the girls carefully think over their images, mixing elements of a classic princess and a creepy monster. Each of the girls has their own special fashion preferences, but when going to class, Laura and Frankie always attract the admiring glances of classmates. After all, they are not just princesses, but real monsters whose terrifying style makes even the bravest tremble!",
      "instructions": "Depending on the gaming device a computer mouse click or a simple touch on touch screens is used to control it The result can be saved as a PNG image ",
      "url": "https://html5.gamemonetize.com/dtfziaj2zz4xglbzcdctg1uqyttpkj3y/",
      "category": "Girls",
      "tags": "Dress Up, Hair, Halloween, Makeover, Monster, School",
      "thumb": "https://img.gamemonetize.com/dtfziaj2zz4xglbzcdctg1uqyttpkj3y/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32364",
      "title": "Good Slice",
      "description": "Come to start a juicy cut fruit journey at Good Slice! This is a casual puzzle game that will test your cutting skills. Your task is to swipe the screen to cut the fruit into perfect pieces and let them fall smoothly into the juicer. The more precise the cut, the more juice youll get!",
      "instructions": "Mouse click or tap to play ",
      "url": "https://html5.gamemonetize.com/1r1xtgybfs46lrr9r5rntmn5ww8vlb63/",
      "category": "Puzzles",
      "tags": "cut, Fruits",
      "thumb": "https://img.gamemonetize.com/1r1xtgybfs46lrr9r5rntmn5ww8vlb63/512x384.jpg",
      "width": "750",
      "height": "1334"
    },
    {
      "id": "32363",
      "title": "Daily Bento Organizer",
      "description": "Do you want to be a bento box master? Using your creativity in the world of the Daily Bento Organizer. To create the most delicious bento box in this casual game. There is the art of food arrangement and the storage management challenge.",
      "instructions": "Mouse click or tap to play ",
      "url": "https://html5.gamemonetize.com/5q2hi88nygzibgvsyrduea8u5zuk60zr/",
      "category": "Hypercasual",
      "tags": "Collection, Puzzle",
      "thumb": "https://img.gamemonetize.com/5q2hi88nygzibgvsyrduea8u5zuk60zr/512x384.jpg",
      "width": "1080",
      "height": "1920"
    },
    {
      "id": "32335",
      "title": "Zombiracer Speed On Earth",
      "description": "Ready to face the zombie apocalypse challenge? In Zombiracer: Speed On Earth, you will enter an exciting track. Merge powerful vehicles, and fight zombies to the death! In this exciting racing game, you can boost your combat power by merging the same vehicle parts. Each vehicle has special attributes and abilities.",
      "instructions": "Mouse click or tap to play ",
      "url": "https://html5.gamemonetize.com/594nplusw7po4zpb6uqgcbi6bdpdb5vh/",
      "category": "Racing",
      "tags": "Superhero, tractor, vehicle",
      "thumb": "https://img.gamemonetize.com/594nplusw7po4zpb6uqgcbi6bdpdb5vh/512x384.jpg",
      "width": "1664",
      "height": "750"
    },
    {
      "id": "32316",
      "title": "Merge Happy Planets!",
      "description": "Classic merge games are coming back with the Merge Happy Planets! Throw the planets and let them merge! Be careful for meteor showers and some mad planets! Use Big Bang Bombs, Rainbow Planets and Black Holes to achieve victory! Try your best. Can you be the number one!?",
      "instructions": "Mouse click to control planets",
      "url": "https://html5.gamemonetize.com/zt9kw0rl1ev6onqgiumhrcx2taik9ag6/",
      "category": "Puzzles",
      "tags": "1 Player, 2D, Arcade, Best, Brain, Crazy, Space",
      "thumb": "https://img.gamemonetize.com/zt9kw0rl1ev6onqgiumhrcx2taik9ag6/512x384.jpg",
      "width": "540",
      "height": "960"
    },
    {
      "id": "32315",
      "title": "Wall Of Danger Dash",
      "description": "A journey to save a Friend and to teach a lesson to the bad monster. Game story begins with Jake and Lily, among them Lily was snatched by a bad monster named Shadow Loomed. Monster gave a challenge to Jack to come and get his friend Lily. Jack is brave enough to accept the challenge. Now the player has to play the role of Jack and help toward his journey. There are many traps and monsters waiting for him but you have to overcome and kill all the enemies to save his friend. Features of this game: High Quality graphics Game size is minimal Super simple controls Interesting Quests",
      "instructions": "How to play Android Use On-Screen touch buttons to control the player PC Move Left Left Arrow Move Right Right Arrow Jump Up Arrow ",
      "url": "https://html5.gamemonetize.com/fvjp9obhregh67131r2fz47r2vsaoaoj/",
      "category": "Hypercasual",
      "tags": "2D, Adventure, Casual, Side Scrolling, survival",
      "thumb": "https://img.gamemonetize.com/fvjp9obhregh67131r2fz47r2vsaoaoj/512x384.jpg",
      "width": "1280",
      "height": "720"
    },
    {
      "id": "32305",
      "title": "Stick Man Battle Fighting",
      "description": "Enter the world of Stick Man Battle Fighting and every move matters! This casual fighting game lets you unleash your skills in dynamic stickman battles against enemies. Master various fighting styles and begin exciting single-mode combat. Choose a weapon and customize your hero.",
      "instructions": "Mouse click or tap to play ",
      "url": "https://html5.gamemonetize.com/lyqrzmhsa4gdejjhe2c1fadi6uw6gaen/",
      "category": "Fighting",
      "tags": "Battle, Fight, Superhero",
      "thumb": "https://img.gamemonetize.com/lyqrzmhsa4gdejjhe2c1fadi6uw6gaen/512x384.jpg",
      "width": "1920",
      "height": "1080"
    },
    {
      "id": "32303",
      "title": "Mini Boxing",
      "description": "Mini Boxing is a fantastic super-deformed boxing game where you control the boxer Nick-Joe and help him win the Boxer Championship Tournament! To claim victory, youll need to face and defeat six unique and quirky boxers, each with their own fighting style. The game is incredibly easy to play, with three main moves: Mini Boxing is inspired by classic 1980s arcade games, featuring charming super-deformed graphics and smooth animations.",
      "instructions": "Key Controls Left Move Left Right Move Right UP Block Z classic light jab X medium straight punch C super heavy uppercut punch ",
      "url": "https://html5.gamemonetize.com/wgdaxwl09pqgakqlidsvnv9ah5wdk2lc/",
      "category": "Sports",
      "tags": "Arcade, Boxing, Fight, Fighting, HTML, HTML5, mapi games, Sport",
      "thumb": "https://img.gamemonetize.com/wgdaxwl09pqgakqlidsvnv9ah5wdk2lc/512x384.jpg",
      "width": "1280",
      "height": "600"
    },
    {
      "id": "32292",
      "title": "Advanture Of Tommy",
      "description": "Explore the adventure and fun game Adventure of Tommy In this adventure many mysterious traps and dangers were waiting for The main character Tommy Player has to play the role of Tommy and finish each level and collect gold coins. If you like genres such as adventure, action, rpg, platform, quests or just want to have a good time then this game is for you. Features of this game: High Quality graphics Game size is minimal Super simple controls Interesting Quests",
      "instructions": "How to play Android Use On-Screen touch buttons to control the player PC Move Left - Press ldquo Left Arrow rdquo Move Right - Press ldquo Right Arrow rdquo Jump - Press ldquo Up Arrow rdquo ",
      "url": "https://html5.gamemonetize.com/z9gmyi01i5dsgspg3lb1mdp5m882w1mt/",
      "category": "Hypercasual",
      "tags": "2D, Adventure, Casual, Platform, Side Scrolling",
      "thumb": "https://img.gamemonetize.com/z9gmyi01i5dsgspg3lb1mdp5m882w1mt/512x384.jpg",
      "width": "854",
      "height": "480"
    },
    {
      "id": "32285",
      "title": "Gold Miner Tower Defense",
      "description": "Gold Miner Tower Defense is a wonderful combination of tower defense, card strategy and upgrade combat. You will play as a brave miner protecting gold from enemies. Protect your precious treasures strategically with many unique defense towers!",
      "instructions": "Mouse click or tap to play ",
      "url": "https://html5.gamemonetize.com/ukcyc9vpff2jus19qjkt6gbxxoyo84qw/",
      "category": "Hypercasual",
      "tags": "Strategy, Tower Defense",
      "thumb": "https://img.gamemonetize.com/ukcyc9vpff2jus19qjkt6gbxxoyo84qw/512x384.jpg",
      "width": "720",
      "height": "1280"
    },
    {
      "id": "32284",
      "title": "Z Machine",
      "description": "In the Z-Machine, you will be in a vibrant arcade world. Take on hordes of zombies in a powerful tank! Your mission is to destroy the zombie and get the money, and then ship it back to the warehouse.Upgrade your vehicle at the same time to improve combat effectiveness and defense!",
      "instructions": "Mouse click or tap to play ",
      "url": "https://html5.gamemonetize.com/6pb58yxizvrukc8x8wvbf3tqnaoffbtq/",
      "category": "Hypercasual",
      "tags": "Car, survival, Zombie",
      "thumb": "https://img.gamemonetize.com/6pb58yxizvrukc8x8wvbf3tqnaoffbtq/512x384.jpg",
      "width": "720",
      "height": "1280"
    },
    {
      "id": "32281",
      "title": "Bottle Battle",
      "description": "This is a puzzle game, the game provides different volumes of the kettle, according to the game level prompts each kettle needs a different magnitude, to reach the required magnitude of the prompt can be cleared",
      "instructions": "The main control of the game is to click on the water bottle to pour water into another water bottle",
      "url": "https://html5.gamemonetize.com/a7fognb5ezg1z5x7x1b23f4t6z5tk1gc/",
      "category": "Hypercasual",
      "tags": "1 Player, 2D, Interactive, water",
      "thumb": "https://img.gamemonetize.com/a7fognb5ezg1z5x7x1b23f4t6z5tk1gc/512x384.jpg",
      "width": "1080",
      "height": "1920"
    },
    {
      "id": "32250",
      "title": "Neon Billard Pool",
      "description": "Play a game of pool to have fun and enjoy and play with a friend, each one plays a round, one is the yellow player and the other is the red player! Have fun!",
      "instructions": "Use the mouse to control and bounce the white ball ",
      "url": "https://html5.gamemonetize.com/bfy6fbzievlze6nan6vk7eyanal6ybaz/",
      "category": "Hypercasual",
      "tags": "2 Player, 8 Ball Pool, Ball, Best Games, Billiard, Casual, crash, Fun, Math",
      "thumb": "https://img.gamemonetize.com/bfy6fbzievlze6nan6vk7eyanal6ybaz/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32325",
      "title": "Math Driving Test",
      "description": "Drive and grab the objects to get the requested amount of unit cubes as quickly as possible. You have to get a medal to pass each level. Hitting tree or building or fence 3 times fails the game. Use the arrow keys I WASD or arrow buttons (mobile) to accelarate and steer the car.",
      "instructions": "WASD arrow buttons",
      "url": "https://html5.gamemonetize.com/souihl4o9tpdd7xadmz778waakj6m29m/",
      "category": "Sports",
      "tags": "3D Games, drifting, Driving, Math, Race",
      "thumb": "https://img.gamemonetize.com/souihl4o9tpdd7xadmz778waakj6m29m/512x384.jpg",
      "width": "640",
      "height": "360"
    },
    {
      "id": "32339",
      "title": "Draw Save Puzzle",
      "description": "Draw Save Puzzle - draw one line to save Stickman from the threat! Are you a good artist or Do you want to test your creative skills? Are you a fan of puzzles? Now you have a good chance! Draw a line to help the little man and protect him from swords, bullets, bombs.... and many other life-threatening attacks! You are free to draw any cover and protection to help the little man survive. Learn to draw lines creatively, develop logic and grow your brain! GAME FEATURES + Lots of levels and endless fun! + Never be bored again! + Simple but amazing physics system! + Improve your brain! + Exciting and relaxing gameplay.",
      "instructions": " Draw only one continuous line to complete the level task Make sure your line does not damage the Stickman you need to protect There can be more than one answer Draw any thing you want as each one can be a solution to the challenge ",
      "url": "https://html5.gamemonetize.com/76kn0zqb9ti95c31997em839qaaq0bj2/",
      "category": "Fighting",
      "tags": "1 Player, 2D, Arcade, Best Games, Bird, Brain, Casual, Game, Games, Puzzle, Stickman",
      "thumb": "https://img.gamemonetize.com/76kn0zqb9ti95c31997em839qaaq0bj2/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32340",
      "title": "Warfare Area 3",
      "description": "Play 3D first person shooter game Warfare Area 3. Your mission is to explore the enemy base and take down all the guards in the area. Shoot enemies, pick up first aid kits and earn money to upgrade the armor and guns.",
      "instructions": "Computer Arrow keys or W A S D to move the character Mouse to turn the character aim and shoot L to lock pointer R to reload P - pause Mobile Use on-screen joystick to move fire button to shoot tap and drag on right side of the screen to aim and",
      "url": "https://html5.gamemonetize.com/9xa5tfoih6vphdexzk034fl8ycjwzffz/",
      "category": "Shooting",
      "tags": "3D, 3D Games, Action, Android, Army, Boys, Bullet, Enemy, fps, Gun, HTML5, iPhone, Killing, military",
      "thumb": "https://img.gamemonetize.com/9xa5tfoih6vphdexzk034fl8ycjwzffz/512x384.jpg",
      "width": "900",
      "height": "506"
    },
    {
      "id": "32341",
      "title": "Do not enter this game at night",
      "description": "Do not enter this game at night, because in this game you will find the most creepy screamers during the passage of the maze, playing for the ball. But if you decide to go in, then you will find a lot of levels, puzzles and, of course, screamers.",
      "instructions": "P Keys W A S D - Move Smartphones A joystick on the screen from the bottom left ",
      "url": "https://html5.gamemonetize.com/tpfvbgcyqy5wzsklzb9bykqldr4ut6hw/",
      "category": "Puzzles",
      "tags": "1 Player, 3D, 3D Games, Adventure, amazing, Ball, Horror, Mobile, New, unity, unity games, unity games for your site, unity games for your website, Unity3D",
      "thumb": "https://img.gamemonetize.com/tpfvbgcyqy5wzsklzb9bykqldr4ut6hw/512x384.jpg",
      "width": "1280",
      "height": "720"
    },
    {
      "id": "32351",
      "title": "Cut Cut Game",
      "description": "The rabbit Dorote, owner of an orchard, was preparing for an event in her village. When inspecting his oranges, he noticed that some of them were hiding explosive surprises, left by someone. However, she was in a hurry and couldnt handle it now, as she needed to prepare the juice for the event. Help her cut the oranges carefully, avoid cutting the wrong things!",
      "instructions": "Tap and slide with your FINGER or use YOUR MOUSE to cut the oranges",
      "url": "https://html5.gamemonetize.com/y610ae7x8dvdis9ertudfnqkxbv810v5/",
      "category": "Hypercasual",
      "tags": "1 Player, 2D, Android, Arcade, Best Games, Bomb, Click, cut, eggs, Rabbit, Samurai, Sword, touch, touchscreen",
      "thumb": "https://img.gamemonetize.com/y610ae7x8dvdis9ertudfnqkxbv810v5/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32380",
      "title": "Find The  Correct Shadow",
      "description": "Find The Correct Shadow is a fun and educational puzzle game designed to challenge your visual skills! In each round, youll be presented with a picture and three shadow options. Only one of the shadows matches the picture perfectly&amp;mdash;can you find the correct one? With three exciting game modes to choose from: Streak Mode: Test how long you can maintain a perfect streak of correct answers! Timed Mode: Race against the clock and see how many correct shadows you can find in a limited time! Learning Mode: A relaxed mode designed to help you practice and improve your visual recognition skills.",
      "instructions": "Mouse click or tap to play",
      "url": "https://html5.gamemonetize.com/3m043n1cb8et8w63mdahpdqao96trr6u/",
      "category": "Puzzles",
      "tags": "Difference, Educational",
      "thumb": "https://img.gamemonetize.com/3m043n1cb8et8w63mdahpdqao96trr6u/512x384.jpg",
      "width": "560",
      "height": "854"
    },
    {
      "id": "32392",
      "title": "Cooking Fever Happy Chef",
      "description": "Are you ready to make your mark on Cooking Fever: Happy Chef? This interesting simulation lets you feel the fun of cooking, serving and managing your restaurant! With colorful graphics and special gameplay, put yourself in the food world and try to become the ultimate chef!",
      "instructions": "Mouse click or tap to play ",
      "url": "https://html5.gamemonetize.com/0nfy14ng1ltqdxupj8vumbrqrz8kcnur/",
      "category": "Hypercasual",
      "tags": "Food, Restaurant, Simulation",
      "thumb": "https://img.gamemonetize.com/0nfy14ng1ltqdxupj8vumbrqrz8kcnur/512x384.jpg",
      "width": "1280",
      "height": "720"
    },
    {
      "id": "32400",
      "title": "Sawblade Fest Run",
      "description": "Like cutting things into many pieces? Challenge your reflexes in Sawblade Fest Run! In this intense arcade game, your goal is very simple. Keep running, avoiding deadly obstacles like iron sheets, walls, and other giant fruit monsters!",
      "instructions": "Mouse click or tap to play ",
      "url": "https://html5.gamemonetize.com/jwrsy3u3pe26a9duc6houu4ouc0bsad5/",
      "category": "Racing",
      "tags": "Arcade, Fruits, Jigsaw",
      "thumb": "https://img.gamemonetize.com/jwrsy3u3pe26a9duc6houu4ouc0bsad5/512x384.jpg",
      "width": "576",
      "height": "1024"
    },
    {
      "id": "32402",
      "title": " Kitchen Sorting",
      "description": "Kitchen Sorting uses well known meachanics of ball and water sorting games. Sort cooking ingredients into glass jars right in your comfortable kitchen. When sorted, pour them into the pot a cook meals.",
      "instructions": "Tap jar to pick one or more ingredients of the same kind from the top Tap another jar to drop them in You can drop them only on top of the same kind of ingredients or into an empty jar You can use swipe from source jar to destination one instead of tap",
      "url": "https://html5.gamemonetize.com/qt9jxy4clkxrv1zharuv23dr2vl4ohhe/",
      "category": "Puzzles",
      "tags": "Ball, Cook, Cooking, Food, Logic, Puzzle, sorting, water",
      "thumb": "https://img.gamemonetize.com/qt9jxy4clkxrv1zharuv23dr2vl4ohhe/512x384.jpg",
      "width": "600",
      "height": "800"
    },
    {
      "id": "32413",
      "title": "321 Diferent Patch",
      "description": "321 Diferent Patch is a casual, quick-play game in which you have to discover the different figure among several that look the same. You have three seconds to find the different figure. Look at every detail, that can make the difference. The difficulty increases with every step. And be careful, the figure that is wrong once, may be the right one the next time. Do you want to play quietly? Relax mode is for you. Just like Normal mode, but with plenty of time to examine the figures. And if youre ready, try the Extreme mode.",
      "instructions": "Mouse click or tap ",
      "url": "https://html5.gamemonetize.com/j3a9bdajchqcaca8hztgb37a89baazdo/",
      "category": "Puzzles",
      "tags": "Casual, Difference, Mind, Skill, Skills",
      "thumb": "https://img.gamemonetize.com/j3a9bdajchqcaca8hztgb37a89baazdo/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32428",
      "title": "Mechangelion Robot Fight",
      "description": "Want to fight robots in a mechanical arena? Mechangelion: Robot Fight is a 3D robot action game full of blood. Let you incarnate as a powerful mechanical warrior, and set foot on the peak of the fight! You will as a super robot and engage in fierce battles with enemies.",
      "instructions": "Mouse click or tap to play ",
      "url": "https://html5.gamemonetize.com/1n7eufky9udoq7ran8na3nc3n4jv3000/",
      "category": "Arcade",
      "tags": "attack, Fight, Robot",
      "thumb": "https://img.gamemonetize.com/1n7eufky9udoq7ran8na3nc3n4jv3000/512x384.jpg",
      "width": "720",
      "height": "1280"
    },
    {
      "id": "32450",
      "title": "Black Sphere",
      "description": "In front of you on the screen you will see a playing field on which you will see several round cells. One of them will contain a white ball. One of the cells will be highlighted in a specific color. A black ball will appear at the top of the playing field. You can use the mouse to move it to one of the cells. This must be done in such a way that the black ball then pushes the white one, and it ends up in the selected cell. If you manage to do this, then you will be given points in the Black Sphere game and you will move to the next level of the game.",
      "instructions": "Mouse click or tap to play",
      "url": "https://html5.gamemonetize.com/zzmd60946ofjq4eyfq9dmdjyaqrkd8pt/",
      "category": "Puzzles",
      "tags": "Best, Brain, Fun, Kids, Logic, Logical, Mobile, Skill",
      "thumb": "https://img.gamemonetize.com/zzmd60946ofjq4eyfq9dmdjyaqrkd8pt/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32457",
      "title": "Stick Archer Champion",
      "description": "Defeat other stick figures and show the world whos the finest archer in Stick Archer Champion, an action game. Delve into the realm of stick figures and unearth their secret meanings. Arm yourself with better bows, arrows, quivers, and shields. Learn new talents and unlock new effects to unlock more arrows. Add personality to your stickman by letting him wear a variety of caps, masks, hairdos, beards, and animations. Add more stickers to the stickman flag collection.",
      "instructions": "Instructions Move from side to side to better aim at your enemy and avoid enemy arrows You can collect many coins with each completed level and with those coins improve your arrows unlock new skin and powers Controls Mouse click to select Keys A D a",
      "url": "https://html5.gamemonetize.com/sau8efctplff566hb06hzx5jyhgu6xyd/",
      "category": "Fighting",
      "tags": "arrows, kiz10, Shooting, Stickman",
      "thumb": "https://img.gamemonetize.com/sau8efctplff566hb06hzx5jyhgu6xyd/512x384.jpg",
      "width": "900",
      "height": "600"
    },
    {
      "id": "32458",
      "title": "Launch Jack",
      "description": "Launch Jack is an exciting physics-based game where you catapult pumpkins to destroy zombie heads and save Halloween night! As Jack, the fearless pumpkin, you&amp;rsquo;ll launch yourself through spooky, haunted landscapes, aiming to eliminate all zombie heads standing in your way. Strategize your shots, break through tricky obstacles, and unleash powerful combos to clear each level. With increasing challenges, eerie settings, and special power-ups, your goal is simple: destroy all the zombie heads and rescue Halloween from disaster!",
      "instructions": "Mouse click or tap to play",
      "url": "https://html5.gamemonetize.com/bm57pfcx9wun729i5z0nl4xfelok6g88/",
      "category": "Puzzles",
      "tags": "Family, Halloween, mapi games, Puzzle",
      "thumb": "https://img.gamemonetize.com/bm57pfcx9wun729i5z0nl4xfelok6g88/512x384.jpg",
      "width": "1024",
      "height": "600"
    },
    {
      "id": "32467",
      "title": "Rolling Ball Halloween Escape",
      "description": "Want to have a terrifying adventure in Rolling Ball Halloween scape? This exciting game invites you to roll through a scary world. Here is full of many vivid Halloween decorations! Roll your ball through the eerie sky, avoid obstacles, and escape the haunted landscape! Control your ball,speeding it up or backing it through many obstacles.Pay attention to avoiding swinging pendulums,shattering boxes and so on.",
      "instructions": "Mouse click or tap to play ",
      "url": "https://html5.gamemonetize.com/govh3xheo7xcct4h7lkbiu5ka4ts1b3h/",
      "category": "Arcade",
      "tags": "Ball, Escape, Halloween",
      "thumb": "https://img.gamemonetize.com/govh3xheo7xcct4h7lkbiu5ka4ts1b3h/512x384.jpg",
      "width": "720",
      "height": "1280"
    },
    {
      "id": "32476",
      "title": "Push The Frog",
      "description": "Control your little frog to eat all the mosquitoes. Master the length of the frogs tongue and make the frog reach the appropriate position to eat the mosquitoes. Think carefully about planning the route. The game has a simple and interesting style, and the gameplay is educational and novel. It is very suitable for playing when killing time.",
      "instructions": "WASD or arrows to move Spacebar pops out the frogs tongue",
      "url": "https://html5.gamemonetize.com/cd4hjkqwg8pgx61kolqxllt3x4rj7v1j/",
      "category": "Puzzles",
      "tags": "Animal, Brain, H5, Kids, Levels, Logic, Logical, Online",
      "thumb": "https://img.gamemonetize.com/cd4hjkqwg8pgx61kolqxllt3x4rj7v1j/512x384.jpg",
      "width": "750",
      "height": "1334"
    },
    {
      "id": "32483",
      "title": "Lift The Girl",
      "description": "Lift The Girl is a free online adventure game for kids, which with rich levels, 2D perspective, fresh style, cartoon skin, and a random combination of level challenges that will surely open your eyes. Different levels have different traps, do not let the little sister hurt, or you will have to start all over again. Interested friends come to experience it!",
      "instructions": "Use the Mobile Left Click Mouse Button To Drag and Drop the weights Click On The Character To Move",
      "url": "https://html5.gamemonetize.com/dbm8az5wd2ein808z0u8x3lgqp6rt3h8/",
      "category": "Puzzles",
      "tags": "2D, amazing, Boy, Fun, Girl, Puzzle",
      "thumb": "https://img.gamemonetize.com/dbm8az5wd2ein808z0u8x3lgqp6rt3h8/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32492",
      "title": "Match 3D Puzzle Mania",
      "description": "Enter the world of match-3 game brought to life in 3D. Solve captivating puzzles and collect coins to acquire power-ups. Complete daily tasks to earn fantastic bonuses and experience endless fun with every move you make!",
      "instructions": "The game features limitless levels Players match objects to clear levels and progress Each level has three difficulties and four unique abilities that help overcome challenges Daily quests and rotating events provide opportunities for additional reward",
      "url": "https://html5.gamemonetize.com/dknfzlo018fucv5igyifvwuiprwrhtxy/",
      "category": "Puzzles",
      "tags": "3D, Casual, Color, Coloring, Logic, Match 3, Match3, Puzzle",
      "thumb": "https://img.gamemonetize.com/dknfzlo018fucv5igyifvwuiprwrhtxy/512x384.jpg",
      "width": "600",
      "height": "800"
    },
    {
      "id": "32499",
      "title": "Football Leauge",
      "description": "Step into the thrill of the stadium with Football League, a fast-paced, action-packed soccer game where you lead your team to victory! Choose your players, master your tactics, and score incredible goals to climb the ranks and become the champion. With intuitive controls, stunning graphics, and dynamic gameplay, Football League delivers an immersive soccer experience for players of all skill levels.",
      "instructions": "Desktop Tap the right buttons of the mouse to throw the ball to other player Mobile Tap the screen to throw the ball to other player ",
      "url": "https://html5.gamemonetize.com/qahsfosbapnzdo3ya16hjf9uudzw7eob/",
      "category": "Sports",
      "tags": "1 Player, Football, NapTech Games, Sport, Sports",
      "thumb": "https://img.gamemonetize.com/qahsfosbapnzdo3ya16hjf9uudzw7eob/512x384.jpg",
      "width": "720",
      "height": "1280"
    },
    {
      "id": "32531",
      "title": "Oil Tank Truck Driving Sim",
      "description": "Oil Tank Truck Driving Sim offers a realistic experience of transporting oil across diverse terrains, featuring authentic physics and traffic scenarios. While it provides an immersive trucking experience, similar games like Oil Tanker Truck Drive and Oil Truck Games: Driving Games also offer comparable gameplay elements. Web Dev &lt;a href='https://www.crazygamesx.com/'&gt;https://www.crazygamesx.com/&lt;/a&gt;",
      "instructions": "WASD to drive",
      "url": "https://html5.gamemonetize.com/9u4hs7eoy90iuifdvh89k5l5h60x0tab/",
      "category": "Action",
      "tags": "Mentolatux, Simulator, transport, Truck, trucks, Unity3D, vehicle, WebGL",
      "thumb": "https://img.gamemonetize.com/9u4hs7eoy90iuifdvh89k5l5h60x0tab/512x384.jpg",
      "width": "800",
      "height": "600"
    },
   
    {
      "id": "32509",
      "title": "Fire Truck Driving Simulator 2024",
      "description": "In Fire Truck Driving Simulator 2024, players step into the role of a heroic firefighter, driving powerful fire trucks through busy city streets, rural roads, and treacherous mountain paths. The objective is to reach emergency scenes quickly and efficiently, navigating obstacles and traffic while keeping the team safe. Players must master vehicle controls, use sirens strategically to clear paths, and stay calm under pressure. WASD to drive , Web Dev &lt;a href='https://www.bestcrazygames.com/'&gt;https://www.bestcrazygames.com/&lt;/a&gt;",
      "instructions": "WASD to drive",
      "url": "https://html5.gamemonetize.com/ndh1rwjfkejjktdkkwb2bl80tgpg5l03/",
      "category": "Action",
      "tags": "Fire, firefighters, Mentolatux, Simulator, Truck, trucks, vehicle",
      "thumb": "https://img.gamemonetize.com/ndh1rwjfkejjktdkkwb2bl80tgpg5l03/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32386",
      "title": "Animate.Space: Create Animated GIF!",
      "description": "Animate.Space is a game where you can create cartoons, GIFs, and flipbooks directly in your browser. With almost unlimited frames and a variety of drawing tools (paint bucket, eraser, pixel and vector shapes), you can bring your ideas to life through frame-by-frame animation. Easily manage frames (copy, paste, delete), select, move, rotate, resize objects, and undo actions without limits. Save your projects as animated GIFs or share them online, while features like autoframe drawing, ghost preview, and line control help you create smooth, professional-looking animations. No watermarks, no sign-up required &amp;mdash; just pure creativity!",
      "instructions": "Use mouse to draw and use various drawing tools",
      "url": "https://html5.gamemonetize.com/zvluq2l3w4mxywskmoca63u5mm21uvd6/",
      "category": "Action",
      "tags": "Cartoon, Design, Draw, Drawing, Stickman",
      "thumb": "https://img.gamemonetize.com/zvluq2l3w4mxywskmoca63u5mm21uvd6/512x384.jpg",
      "width": "960",
      "height": "600"
    },
    {
      "id": "32345",
      "title": "American Block Sniper Survival Online",
      "description": "In the first-person action game American Block Sniper Online, set in the Minecraft universe, your objective is to clear each level of all adversaries before the timer runs out. You begin each level with only a rifle, but youll discover and equip a wide variety of weaponry as you go. It takes anything from two to five minutes to complete a level, give or take depending on your score. At this point, you should aim to vanquish every enemy that shows up on the map.",
      "instructions": "Instructions Move around the map between buildings collect weapons to eliminate enemies positioned throughout the city W A S D to walk around Mouse to Look around Left Mouse Button to Fire Right Mouse Button to Aim Mouse Wheel To Change Weapons G for G",
      "url": "https://html5.gamemonetize.com/dy2tps9hmgrhuwhk557cdykcx3puevbb/",
      "category": "Action",
      "tags": "kiz10, mineblock, Shooting, Sniper",
      "thumb": "https://img.gamemonetize.com/dy2tps9hmgrhuwhk557cdykcx3puevbb/512x384.jpg",
      "width": "900",
      "height": "600"
    },
    {
      "id": "32287",
      "title": "Warriors Line Up",
      "description": "Immerse yourself in a simple yet thrilling gameplay experience filled with dynamic skills, stunning graphics, and a plethora of challenging enemies. With intuitive mobile controls, you can move swiftly, launch attacks, and deploy powerful skills. Engage in addictive battles that showcase a diverse array of combat techniques, promising an enthralling and captivating adventure for all players.",
      "instructions": "Mouse click or tap to play",
      "url": "https://html5.gamemonetize.com/qxne2dcajybwp6dh2txkiignwfyp569x/",
      "category": "Action",
      "tags": "Click, Mentolatux, Sword, Top Down, Unity3D, War, Warrior, WebGL",
      "thumb": "https://img.gamemonetize.com/qxne2dcajybwp6dh2txkiignwfyp569x/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32247",
      "title": "Offroad Truck Army Driving",
      "description": "In Offroad Truck Army Driving, players navigate rugged mountain terrains and diverse environments. With three types of military vehicles, players take on challenging missions across three unique packs. Experience intense off-road action, conquering steep hills, muddy trails, and rocky landscapes as you complete various army driving tasks, all while mastering the toughest off-road challenges. Web Dev &lt;a href='https://www.kizi10.org/'&gt;https://www.kizi10.org/&lt;/a&gt;",
      "instructions": "WASD drive",
      "url": "https://html5.gamemonetize.com/43fe8rc64mstpvw5zf24lct45nptj2mn/",
      "category": "Action",
      "tags": "Army, Driving, Mentolatux, mountain, offroad, Truck, trucks, Unity3D, WebGL",
      "thumb": "https://img.gamemonetize.com/43fe8rc64mstpvw5zf24lct45nptj2mn/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32246",
      "title": "Goodnight My Baby",
      "description": "Are you interested in the world of baby monsters? Do you want to know what the home of the baby monsters looks like when night falls? Our game can satisfy your curiosity. You can go into their home and put the baby to sleep.",
      "instructions": "Mouse click or tap to play ",
      "url": "https://html5.gamemonetize.com/34sllctljd4vlu5n7cno56dm97mlfafb/",
      "category": "Action",
      "tags": "Monster, Panda",
      "thumb": "https://img.gamemonetize.com/34sllctljd4vlu5n7cno56dm97mlfafb/512x384.jpg",
      "width": "1920",
      "height": "1080"
    },
    {
      "id": "32234",
      "title": "Offroad Cargo Truck 2024",
      "description": "The 2024 Offroad Cargo Truck roars through lush forest trails, showcasing its rugged durability and advanced suspension. Equipped with high-clearance wheels and all-terrain tires, the driver expertly navigates winding paths. The truck&amp;rsquo;s spacious cargo area carries essential gear, while the vibrant greenery and serene environment enhance the adventurous spirit. Sunlight filters through towering trees, creating a perfect backdrop for offroad exploration. Web Dev &lt;a href='https://www.newcrazygames.com/'&gt;https://www.newcrazygames.com/&lt;/a&gt;",
      "instructions": "WASD drive",
      "url": "https://html5.gamemonetize.com/uayd9hwxcusn9oarblbqypwsq5g520xk/",
      "category": "Action",
      "tags": "Driving, Forest, Mentolatux, offroad, Simulator, Truck, Unity3D, WebGL",
      "thumb": "https://img.gamemonetize.com/uayd9hwxcusn9oarblbqypwsq5g520xk/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32225",
      "title": "Vehicle Transport Police Simulator",
      "description": "Vehicle Transport Police Simulator is an action-packed game where players drive various vehicles, including buses, jeeps, and trucks, to transport military personnel to their destinations. With challenging missions, diverse terrains, and realistic driving mechanics, players must navigate obstacles and ensure safe, timely delivery of troops while maintaining law and order. Web Dev &lt;a href='https://www.kizi10.org/'&gt;https://www.kizi10.org/&lt;/a&gt;",
      "instructions": "WASD to drive",
      "url": "https://html5.gamemonetize.com/sro33w89adskjdtlk9cwktqjdd1csm90/",
      "category": "Action",
      "tags": "Army, bus, Car, Cars, Driving, Mentolatux, military, Simulation, Truck, Unity3D, WebGL",
      "thumb": "https://img.gamemonetize.com/sro33w89adskjdtlk9cwktqjdd1csm90/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32217",
      "title": "Truck Simulator Construction",
      "description": "Truck Simulator Construction is a realistic simulation game where players take control of various heavy-duty trucks and machinery to complete challenging construction tasks. From transporting materials to operating cranes and excavators, players must manage time and resources to build structures, roads, and more. With immersive environments and detailed vehicles, experience the life of a construction site worker!",
      "instructions": "WASD - drive",
      "url": "https://html5.gamemonetize.com/u06e6by2a28avhtl0x368c7wv2jnh1tz/",
      "category": "Action",
      "tags": "city, Driving, Mentolatux, Simulation, Truck, Unity3D, WebGL",
      "thumb": "https://img.gamemonetize.com/u06e6by2a28avhtl0x368c7wv2jnh1tz/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32191",
      "title": "Fall Guys 2024",
      "description": "Fall Guys 2024 is a vibrant, offline battle royale where players navigate whimsical obstacle courses and compete in zany minigames. With enhanced customization options, seasonal events, and chaotic fun, it challenges players to outwit and outlast others in a series of playful and hilarious rounds. Experience a colorful frenzy of competition and teamwork in this ever-evolving game. Web Dev &lt;a href='https://www.insanegamesonline.com/'&gt;https://www.insanegamesonline.com/&lt;/a&gt;",
      "instructions": "Use Joystick to walk and button SPACE to jump",
      "url": "https://html5.gamemonetize.com/bzv8wjffafspjcaof9hsu8y37iq4toxc/",
      "category": "Action",
      "tags": "Fall Boys, Fall Guys, Fun, Funny, Kids, Mentolatux, Skill, Unity3D, WebGL",
      "thumb": "https://img.gamemonetize.com/bzv8wjffafspjcaof9hsu8y37iq4toxc/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32179",
      "title": "Noob City The Gangster",
      "description": "You get the chance to live out your wildest dreams as a real-life gangster in the thrilling new action game CraftsMan 3D Gangster, which is reminiscent of Minecraft. Other criminals will be waiting to eliminate you when you go out into the open world. Complete this entertaining 3D action game and confront more dangerous foes at each level.",
      "instructions": "What are the finest Roblox games that can be played without downloading them on Kiz10 com Controls Mouse To LookW A S D To DriveSpace To Hand BreakF To Exit Vehicle",
      "url": "https://html5.gamemonetize.com/jsi5x60oq85umikv4g48xnnqms323v4t/",
      "category": "Action",
      "tags": "Fighting, kiz10, run, Shooter",
      "thumb": "https://img.gamemonetize.com/jsi5x60oq85umikv4g48xnnqms323v4t/512x384.jpg",
      "width": "900",
      "height": "600"
    },
    {
      "id": "32135",
      "title": "Auto Bus Driving 2024",
      "description": "Auto Bus Driving 2024 offers a thrilling and realistic driving experience with the latest buses on diverse city routes. Navigate through challenging traffic, weather conditions, and time-sensitive schedules. With enhanced graphics and dynamic controls, this simulation game allows players to master driving skills, manage passengers, and explore detailed urban landscapes. Web Dev &lt;a href='https://www.kizi10.org/'&gt;https://www.kizi10.org/&lt;/a&gt;",
      "instructions": "WASD to drive",
      "url": "https://html5.gamemonetize.com/ypz3l7ed6h45ovjr0k2bg498umzkx7u7/",
      "category": "Action",
      "tags": "bus, city, Driving, Mentolatux, School, Sim, Unity3D, WebGL",
      "thumb": "https://img.gamemonetize.com/ypz3l7ed6h45ovjr0k2bg498umzkx7u7/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32124",
      "title": "Army Bus Driving 2024",
      "description": "Army Bus Driving 2024 immerses players in the challenging world of military transport. Take command of rugged, all-terrain army buses, transporting soldiers and equipment across hostile environments. Navigate through treacherous landscapes, from deserts to mountains, under tight schedules and demanding conditions. With realistic physics, detailed military vehicles, and a variety of missions, this simulation game offers a thrilling and authentic experience for those ready to handle the pressures of army logistics on the road.",
      "instructions": "WASD drive",
      "url": "https://html5.gamemonetize.com/x768a5mk67izz2hv8kxhucmlw49i2ane/",
      "category": "Action",
      "tags": "Action, Army, bus, Driving, Mentolatux, Unity3D, WebGL",
      "thumb": "https://img.gamemonetize.com/x768a5mk67izz2hv8kxhucmlw49i2ane/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32113",
      "title": "Car Stunt Ramp Challenge",
      "description": "Car Stunt Ramp Challenge is an adrenaline-pumping racing game that puts your driving skills to the ultimate test. Get behind the wheel of high-speed cars and take on extreme ramps and obstacle courses designed to push your limits. The game features a variety of stunts, from high-flying jumps to complex flips, all set in vibrant, dynamic environments. Precision and timing are crucial as you race against the clock to complete each challenge. With its realistic physics and thrilling gameplay, Car Stunt Ramp Challenge offers a heart-pounding experience for stunt driving enthusiasts. Are you ready to conquer the ramps?",
      "instructions": "WASD drive",
      "url": "https://html5.gamemonetize.com/omk3dx57djeoq1l1b8kj1r0mz43trze3/",
      "category": "Action",
      "tags": "Car, Driving, Mentolatux, Stunts, Supercars, Unity3D, WebGL",
      "thumb": "https://img.gamemonetize.com/omk3dx57djeoq1l1b8kj1r0mz43trze3/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32097",
      "title": "Real Bus Parking Oick and Drop",
      "description": "Bus Parking: Pick and Drop is an engaging driving simulation game that challenges players to master the art of precision parking while providing a smooth ride for passengers. As a skilled bus driver, your task is to navigate busy city streets, pick up passengers from designated stops, and safely drop them off at their destinations. The game features realistic controls and detailed urban environments, making each level more challenging than the last. Perfecting your parking skills is key to advancing through the levels, ensuring timely and accurate drop-offs. Its a must-try for fans of driving and parking simulation games.",
      "instructions": "WASD drive",
      "url": "https://html5.gamemonetize.com/9gtk3fuj8b3956ikmbul44mumh11hftl/",
      "category": "Action",
      "tags": "bus, carparking, city, Driving, Mentolatux, Parking, Sim, Unity3D",
      "thumb": "https://img.gamemonetize.com/9gtk3fuj8b3956ikmbul44mumh11hftl/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32082",
      "title": "TukTuk Rickshaw City Driving Sim",
      "description": "Step into the role of a legendary city tuk-tuk driver in TukTuk Rickshaw City Driving Sim! Complete your tasks on time to unlock exciting new levels in this thrilling rickshaw driving game. Transport passengers from one point to their destination, mastering the art of precise parking to keep them happy.",
      "instructions": "WASD driving",
      "url": "https://html5.gamemonetize.com/jykqi5zuiofupq2hb774wo0nrtplkfua/",
      "category": "Action",
      "tags": "city, Driving, Rickshaw, Sim, TukTuk, vehicle",
      "thumb": "https://img.gamemonetize.com/jykqi5zuiofupq2hb774wo0nrtplkfua/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32060",
      "title": "Polygon Flight Simulator",
      "description": "Fly like a pro in this airplane simulator; you can smoothly navigate from one airport to another. Its straightforward&amp;mdash;press the W button, drag the mouse, and watch your plane ascend. Skillfully enter airborne checkpoints en route to your next destination airport. With intuitive controls, this simulator provides an immersive flying experience. Whether youre a novice or an expert, the seamless interface ensures an enjoyable journey through virtual skies. Master the art of aviation with this user-friendly simulator. Website Developer &lt;a href='https://www.crazygamesonline.com'&gt;https://www.crazygamesonline.com&lt;/a&gt;",
      "instructions": "WASD move plane Mouse Drag go up Mouse Forwad go Down Mouse Left or right move plane TAB Menu",
      "url": "https://html5.gamemonetize.com/jxcgkmz8u2tpdhvvfed9ecl25bqkspxt/",
      "category": "Action",
      "tags": "Aircraft, airplane, Driving, fly, Mentolatux, Unity3D, vehicle, WebGL",
      "thumb": "https://img.gamemonetize.com/jxcgkmz8u2tpdhvvfed9ecl25bqkspxt/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32058",
      "title": "Imposter Assassin 3D",
      "description": "Play the entertaining 3D action game Imposter Assassin 3D to transform into a true assassin. It has stealth, shooting, action, enemy guards, and a ton of levels and skins to unlock. Assume charge of an imposter who dares to enter the control base. Numerous enemy troops will be patrolling each level, and they will kill you right away if they discover you.",
      "instructions": "Instructions Move stealthily to attack the soldiers from behind so they dont see you to hit the precise attack at the right time and dont leave a single one alive Use the mouse to move and attack Touch the screen and drag on mobile devices ",
      "url": "https://html5.gamemonetize.com/kjixdc9mw89s3k1rdka4eotbmrgggvkn/",
      "category": "Action",
      "tags": "attack, Fighting, Impostor, Shooter",
      "thumb": "https://img.gamemonetize.com/kjixdc9mw89s3k1rdka4eotbmrgggvkn/512x384.jpg",
      "width": "900",
      "height": "600"
    },
    {
      "id": "32053",
      "title": "Water Slide Adventure",
      "description": "Dive into the ultimate water slide adventure with Extreme Water Slide Adventure! Experience the thrill of speeding down giant slides in this offline swimming pool game. As a super slider, youll navigate crazy twists, turns, and daring stunts that will keep you on the edge of your seat. Packed with excitement and fun, this game offers endless enjoyment for all water slide enthusiasts. Are you ready for the ride of your life?",
      "instructions": "WASD - CONTROL the player",
      "url": "https://html5.gamemonetize.com/9jiw9pzfxozl2lnrio0tb50nnwsmwdxq/",
      "category": "Action",
      "tags": "Adventure, Mentolatux, slide, slider, Unity3D, water, waterslide",
      "thumb": "https://img.gamemonetize.com/9jiw9pzfxozl2lnrio0tb50nnwsmwdxq/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32041",
      "title": "Super Hero Sponge",
      "description": "Join the action-packed adventure with Super Hero Sponge! Embark on an epic journey as the brave sponge hero, battling against formidable enemies and monstrous Big Bosses. Team up with friends, overcome challenging obstacles, and save the day with your heroic skills. With thrilling gameplay and exciting challenges, this adventure is perfect for fans of action and fun. Are you ready to become the ultimate Super Hero Sponge? Web Dev &lt;a href='https://www.kizi10.org/'&gt;https://www.kizi10.org/&lt;/a&gt;",
      "instructions": "Controlls WASD Walk X Attack F Fire SPACE Jump",
      "url": "https://html5.gamemonetize.com/wgoul13b9vne3iifz3cpspkq9hf5dcam/",
      "category": "Action",
      "tags": "2D, Mentolatux, Spongebob, Superhero, Unity3D",
      "thumb": "https://img.gamemonetize.com/wgoul13b9vne3iifz3cpspkq9hf5dcam/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32037",
      "title": "Realistic Lion Hunting Animal 2024",
      "description": "Experience the thrill of the wild in Realistic Lion Hunting Animal 2024! This immersive simulator puts you in the paws of a majestic lion, roaming a vast and realistic forest. Hunt various animals to survive and advance through challenging levels. Explore the dense wilderness, track your prey, and feel the rush of the hunt. Perfect for those seeking adventure and excitement in the animal kingdom. Can you survive the wild?",
      "instructions": "WASD Walk LeftShift Run Mouse Right Stop Run Mouse Left Attack ",
      "url": "https://html5.gamemonetize.com/4xgs7sshdp0wpeqsoztn42pdttjiy5jq/",
      "category": "Action",
      "tags": "Action, Animal, attack, Forest, hunter, lion, Mentolatux, Simulation",
      "thumb": "https://img.gamemonetize.com/4xgs7sshdp0wpeqsoztn42pdttjiy5jq/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "31986",
      "title": "Fish Grow Eating Fish",
      "description": "This adventure game is designed to help you unwind! Dive into the underwater world and strive to become the Ocean King. Begin your journey as a small angelfish and grow by quickly consuming smaller fish. The vast ocean is brimming with surprises, so watch out for larger fish that might bite back. Be patient as you grow stronger, and soon youll be able to take on the bigger fish! Web Dev &lt;a href='https://www.kizi10.org/'&gt;https://www.kizi10.org/&lt;/a&gt;",
      "instructions": "WASD controll the fish SPACE attack",
      "url": "https://html5.gamemonetize.com/jfhu1t3dbwz31jo1ka00z0j043vfjzge/",
      "category": "Action",
      "tags": "Action, Android, eating, Fish, HTML5, iPad, iPhone, Kids, Mentolatux, Skill, WebGL",
      "thumb": "https://img.gamemonetize.com/jfhu1t3dbwz31jo1ka00z0j043vfjzge/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "31976",
      "title": "Silent Assassin 2024",
      "description": "Enter the world of Silent Assassin 2024, where your mission is to eliminate monsters with precision and stealth. Click on the screen as the wheel spins, strategically selecting weapons to throw at the approaching creatures. With each accurate shot, you inch closer to victory. Web Dev &lt;a href='https://www.game-plays.com/'&gt;https://www.game-plays.com/&lt;/a&gt;",
      "instructions": "Mouse click or tap to play",
      "url": "https://html5.gamemonetize.com/bigltd28j37dj9b4n1kz1rufoub9fjyd/",
      "category": "Action",
      "tags": "1 Player, Action, assasin, assassin, Mentolatux, Monster, throwing, Unity3D, weapons, WebGL",
      "thumb": "https://img.gamemonetize.com/bigltd28j37dj9b4n1kz1rufoub9fjyd/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "31953",
      "title": "Granny Chapter 3 High School",
      "description": "Chapter 3: High School Escape from Granny is a fun third-person horror game where you must hide from Granny and the specters of Slendrina. Discover the keys to the abandoned schools classrooms, stock up on ammo, and try to stay alive for as long as possible. Find the revolver loaded with ammo and all the keys to the classrooms of the vacant school while Granny and Slendrina chase you. As you go inside the classroom, youll see a single desk that reads Granny and the keys to the locked door. Finally, Slendrina or Granny makes the player",
      "instructions": "The main objective of the game is to try to survive as long as you can by collecting items to hide and escape from Granny Controls WASD to move Right click to shoot F Interact Esc Menu",
      "url": "https://html5.gamemonetize.com/ehnw198451t7cygffbjrs4ac50ue011k/",
      "category": "Action",
      "tags": "Escape, kiz10, Room, Shooting, survival",
      "thumb": "https://img.gamemonetize.com/ehnw198451t7cygffbjrs4ac50ue011k/512x384.jpg",
      "width": "900",
      "height": "600"
    },
    {
      "id": "31950",
      "title": "Swipe To Park The Cars",
      "description": "Swipe To Park The Cars is a captivating 2D mobile game that puts your parking skills to the test. In this addictive title, players must skillfully guide a fleet of colorful cars into their designated parking spots using intuitive swipe controls. The challenge lies in the increasing complexity of parking scenarios, from crowded lots to tight spaces, requiring precision and quick thinking. Web Dev &lt;a href='https://www.crazygamesonline.com/'&gt;https://www.crazygamesonline.com/&lt;/a&gt;",
      "instructions": "Mouse click or tap to play",
      "url": "https://html5.gamemonetize.com/0eii7f3a9spn9lw35vo3ovmpur1120tt/",
      "category": "Action",
      "tags": "Android, Cars, Click, HTML5, iPad, iPhone, Mentolatux, Mobile, Mouse, Parking, Skill, Unity3D, WebGL",
      "thumb": "https://img.gamemonetize.com/0eii7f3a9spn9lw35vo3ovmpur1120tt/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "31943",
      "title": "StickMan Defense",
      "description": "Dive into the thrilling world of StickMan Defense, a captivating game where strategy meets action. In this game, players are tasked with defending their base against waves of incoming enemies, using a variety of stickman warriors. Each level challenges your tactical skills, requiring careful placement of troops and timely upgrades. With intuitive controls and engaging graphics, StickMan Defense offers an immersive experience for both casual and hardcore gamers. Web Dev &lt;a href='https://www.insanegamesonline.com/'&gt;https://www.insanegamesonline.com/&lt;/a&gt;",
      "instructions": "Mouse click or tap to play",
      "url": "https://html5.gamemonetize.com/xnm06hp9o6dt48fua7g3jzoddqnkc5fs/",
      "category": "Action",
      "tags": "Android, Click, Defense, HTML5, iPad, iPhone, Mentolatux, Mobile, Stickman, WebGL",
      "thumb": "https://img.gamemonetize.com/xnm06hp9o6dt48fua7g3jzoddqnkc5fs/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "31816",
      "title": "Knife WAR.IO",
      "description": "Enter Knife WAR.IO, where you face off against hordes of opponents in a fierce battle for dominance! Defeat rivals, gather orbs to level up and earn points. As you progress, grow in size and unlock different skins, evolving into a formidable giant in the arena. Strategize your attacks, dodge enemy knives, and rise to the top of this thrilling multiplayer experience! Website Developer &lt;a href='https://www.bestcrazygames.com'&gt;https://www.bestcrazygames.com&lt;/a&gt;",
      "instructions": "Use joystick to move player and A S D F for attacking other players ",
      "url": "https://html5.gamemonetize.com/xvcym1vb1aesda2konvlw79625pnkr6k/",
      "category": "Action",
      "tags": ".io, .io Games, Knight, Mentolatux, Sword, Unity3D, War, WebGL",
      "thumb": "https://img.gamemonetize.com/xvcym1vb1aesda2konvlw79625pnkr6k/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "31801",
      "title": "Craft Theft War",
      "description": "Immerse yourself in the best open-world action-adventure sandbox game, Craft Theft War, inspired by pixel voxel cube craft style online shooting games. Enjoy a vast selection of action-packed games, cool games, and relaxing games, all within a sprawling sandbox environment. This game offers an unparalleled online gaming experience, combining the best elements of open-world adventure, sandbox gameplay, and multiplayer action. Join the fun today and discover why its one of the best online games!",
      "instructions": "Move WASD Aim Mouse Shoot Left Click Jump Space Sprint Shift Reload R ",
      "url": "https://html5.gamemonetize.com/2w7rnj6q5cnt9jt81l0m7s27uqqyqq0f/",
      "category": "Action",
      "tags": "Action, Battle, Bubble Shooter, Multiplayer, Shooting, War",
      "thumb": "https://img.gamemonetize.com/2w7rnj6q5cnt9jt81l0m7s27uqqyqq0f/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "31750",
      "title": "Fall Boys Ulimate Tournament 2024",
      "description": "Welcome to the Fall Boys Ultimate Tournament 2024! Step into a vibrant world filled with exhilarating challenges and fierce competition. Test your skills in a variety of whimsical mini-games that will push your agility and strategy to the limit. Whether youre dodging obstacles, racing against the clock, or working with teammates, aim to outlast and outperform your opponents. Website Developer &lt;a href='https://www.game-plays.com/'&gt;https://www.game-plays.com/&lt;/a&gt;",
      "instructions": "WASD to walk SPACE to jump ",
      "url": "https://html5.gamemonetize.com/nxl2ybhls0ev61j3bf9zzfmlwnjzwe58/",
      "category": "Action",
      "tags": "Best Games, Fall Boys, Fall Guys, Mentolatux, Multiplayer, run, running, unity games, WebGL",
      "thumb": "https://img.gamemonetize.com/nxl2ybhls0ev61j3bf9zzfmlwnjzwe58/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "31749",
      "title": "Escape Wednesday",
      "description": "Break through the monsters to get out of the maze! Many labyrinths will not let you get bored. Show your abilities and you will be the winner. In Wednesday Escape, youll navigate through intricate mazes filled with challenging monsters. Each level presents unique obstacles that test your skills and strategy. Can you outsmart the creatures and find the exit?",
      "instructions": "Move mouse change direction",
      "url": "https://html5.gamemonetize.com/5fw8d2716dxf4t9semyy8pkkfmzpz0jh/",
      "category": "Action",
      "tags": "3D, Escape, Monster, Skill",
      "thumb": "https://img.gamemonetize.com/5fw8d2716dxf4t9semyy8pkkfmzpz0jh/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32762",
      "title": "Sprunki in Backrooms Christmas Skibidi Terrors",
      "description": "Now Sprunki must escape from Skibidi Toilet in Christmas day. Get all coin to get access to exit. Backroom is so creepy in christmas!",
      "instructions": "WASD to move",
      "url": "https://html5.gamemonetize.com/1dws9womnudxsiqkh056yumex38z3x3v/",
      "category": "Adventure",
      "tags": "Christmas, huggy, Skibidi Toilet, Sprunki",
      "thumb": "https://img.gamemonetize.com/1dws9womnudxsiqkh056yumex38z3x3v/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32737",
      "title": "Go Santa",
      "description": "Go Santa by Gamezad is an engaging mobile game that combines festive cheer with exhilarating gameplay. In this endless runner, you take on the role of Santa Claus as he dashes through a vibrant, snow-covered landscape",
      "instructions": "for mobile use the touch for pc use the mouse",
      "url": "https://html5.gamemonetize.com/sobq6f8owk2qzcsbsg9ajhpf9zl1ggbh/",
      "category": "Adventure",
      "tags": "1 Player, 2D, amazing, Animal, Fun, Funny",
      "thumb": "https://img.gamemonetize.com/sobq6f8owk2qzcsbsg9ajhpf9zl1ggbh/512x384.jpg",
      "width": "1920",
      "height": "1080"
    },
    {
      "id": "32691",
      "title": "Santa Claus Adventures 1",
      "description": "Collect all the gifts with Santa and deliver them to their owners.Pick up the gifts, take them to the gift tree and move on to the next levels.Try not to get stuck in any obstacles while doing these, good luck.",
      "instructions": "W for Jump A for Move Left D for Move Right Double Jump Active",
      "url": "https://html5.gamemonetize.com/bl9jsif89ke2flf8m1ubq26q84pk0o4z/",
      "category": "Adventure",
      "tags": "1 Player, 2D, Action, Adventure, amazing, Arcade, Army, Boys, Christmas",
      "thumb": "https://img.gamemonetize.com/bl9jsif89ke2flf8m1ubq26q84pk0o4z/512x384.jpg",
      "width": "248",
      "height": "112"
    },
    {
      "id": "32682",
      "title": "Santa Dash",
      "description": "Join Santa on a thrilling dash through snowy landscapes! Help him collect coins and avoid obstacles in this festive and fun endless runner game. With simple controls and charming graphics, Santa Dash is perfect for players of all ages. Get ready to spread holiday cheer and see how far you can go!",
      "instructions": "Use arrow keys or touch controls Buttons on mobile to move Santa left right and Jump Collect as many coins as possible to increase your score Avoid obstacles to keep Santa running ",
      "url": "https://html5.gamemonetize.com/rknengrq9tntzjn84bsav8hlq1x2o50t/",
      "category": "Adventure",
      "tags": "1 Player, Adventure, Arcade, Casual, Christmas, endless, Santa, Santa Claus, Snow, Winter",
      "thumb": "https://img.gamemonetize.com/rknengrq9tntzjn84bsav8hlq1x2o50t/512x384.jpg",
      "width": "960",
      "height": "540"
    },
    {
      "id": "32680",
      "title": "Granny House Escape",
      "description": "Enter the spine-chilling world of Granny House Escape, a 3D horror game where your mission is to escape a creepy house controlled by an angry, evil Granny. Search for keys to unlock rooms, each leading to more keys and greater challenges as you try to find your way out. In Granny House Escape, tense game play and eerie visuals create an atmosphere of constant fear. Use your wits to hide from Granny, avoid her wrath, and stay one step ahead as you explore the haunted house. Can you collect all the keys and escape before its too late? Download Granny House Escape now and face your fears!",
      "instructions": "WSQD For Movement Space to Jump Left Shift To Sprint Mobile Virtual Joystick for Movement Touch Screen to look around Touch keys to Jump-Sprint",
      "url": "https://html5.gamemonetize.com/61ur3yqtjcj0hzv0wgrf5jakent38u03/",
      "category": "Adventure",
      "tags": "3D Games, Escape, Granny, Horror, House",
      "thumb": "https://img.gamemonetize.com/61ur3yqtjcj0hzv0wgrf5jakent38u03/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32663",
      "title": "Piano Game star 5",
      "description": "Follow the rhythm! Piano Game star 5 is a relaxing music game with amazing music style as Pop, Classic Piano, T-pop, K-pop, J-pop, EDM, Hip-Hop, R&amp;amp;B, etc. A piano star tap music tiles game for all generations. Kid or adult, all can play this game for relaxing times with trendy and pop music. Tap the black tiles! You can easily perform a song by yourself. With fun and ease, melody and rhythm of piano songs will flow freely by your fingers. Its also a nice choice to test your hand-speed!",
      "instructions": "Mouse click or tap to Play",
      "url": "https://html5.gamemonetize.com/dpjhz1mppb1495dpb9qmbbgdkr77iyzj/",
      "category": "Adventure",
      "tags": ".io Games, 1 Player, 2 Player, 2 Player Games, 3D, 3D Games, Best, Best Games, Boys, Crazy, Girls, Music",
      "thumb": "https://img.gamemonetize.com/dpjhz1mppb1495dpb9qmbbgdkr77iyzj/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32649",
      "title": "Scary House Clown Evil",
      "description": "Scary House Clown Evil is an Exciting Thriller 3D horror game, inspired by all horror films about the best serial killers in their creepy Mansion. You wake up and find yourself trapped inside a scary House with blood and dark feelings, with deadly silence and a dangerous clown murderer whos looking around for his next victim to kill. On Scary House Clown Evil horror game you have to Sneak with stealth and explore the scary Mansion, discover and escape rooms and find Every single key for each Room and watch out for the Creepy Clown killer, whos always so suspicious about an intruders presence Nobody escaped the dark pursuer. Dare you?",
      "instructions": "WSQD For Movement Left Shift To Sprint Mobile Virtual Joystick for Movement Touch Screen to look around",
      "url": "https://html5.gamemonetize.com/44z7cekal1224m2ngzkxkekhgdmn001d/",
      "category": "Adventure",
      "tags": "3D Games, Best Games, Escape, free games for your website, Horror",
      "thumb": "https://img.gamemonetize.com/44z7cekal1224m2ngzkxkekhgdmn001d/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32621",
      "title": "Squid Maze Challenge",
      "description": "Looking for the most realistic Squid game Experience? Well, squid game Maze challenge is the best choice for you! Just like candy and a pin challenge and like Run green and red light with The girl who stands towards the tree and saying green light red light challenge. In this Squid, players are forced to Run inside some mystery Mazes and the goal is to find the Exit Key and go to the finish Door in this squid task 2022, its called squid game Maze challenge. Some glass is easy to break and some are so strong. Be Smart while choosing your steps and paths or you will be Eliminated!",
      "instructions": "WSQD For Movement amp Jump Mouse To Look around Space for Jump Mobile Virtual Joystick for Movement Touch Keys for Jump Run",
      "url": "https://html5.gamemonetize.com/kvflm9cp71z5lt83dqyp6nn3yw8a6ub4/",
      "category": "Adventure",
      "tags": "3D Games, Adventure, Escape, Maze, running",
      "thumb": "https://img.gamemonetize.com/kvflm9cp71z5lt83dqyp6nn3yw8a6ub4/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32599",
      "title": "Tic Tac Toe Pro",
      "description": "Tic Tac Toe Pro is an enhanced version of the classic game, featuring a sleek design, various difficulty levels, and multiplayer options. Play against AI with different skill settings or challenge friends in a competitive environment. Perfect for quick, strategic gameplay on the go. Fun for all ages!",
      "instructions": "Mouse click or tap to play",
      "url": "https://html5.gamemonetize.com/390ok4pjvfy8m5mnb6tn3erqejuwdpp2/",
      "category": "Adventure",
      "tags": "1 Player",
      "thumb": "https://img.gamemonetize.com/390ok4pjvfy8m5mnb6tn3erqejuwdpp2/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32534",
      "title": "SquidGame3D",
      "description": "Engaging Puzzles: Each level offers a unique challenge, whether it&amp;rsquo;s rhythm-based action, strategic battles, or construction puzzles. Diverse Gameplay: No two levels are the same, keeping players engaged and on their toes. Skill Progression: As you advance, levels become more complex, requiring a blend of quick thinking, strategy, and precise execution.",
      "instructions": "On Computer Interact with objects solve puzzles and complete challenges by clicking or dragging items on the screen Precision and quick reactions are key to mastering each level On Mobile Control your character using your fingers Tap the screen to ",
      "url": "https://html5.gamemonetize.com/z5aqdklwpdk31xx7d3mwp2wxgnn67l4f/",
      "category": "Adventure",
      "tags": "3D Games, Adventure, amazing, attack",
      "thumb": "https://img.gamemonetize.com/z5aqdklwpdk31xx7d3mwp2wxgnn67l4f/512x384.jpg",
      "width": "960",
      "height": "600"
    },
    {
      "id": "32491",
      "title": "Staircase To Heaven",
      "description": "Embark on an exhilarating journey from ground zero to the skies in Only Up! However, theres a twist &amp;ndash; no checkpoints exist on this ascent. Stumble, and you must swiftly catch yourself to avoid losing precious progress. Will you conquer the summit, or succumb to the challenge and give up?",
      "instructions": "Use W A S D to move forward Use Shift To Run Use Space To Jump Use Key L To Lock and Unlock Cursor ",
      "url": "https://html5.gamemonetize.com/wjtcbugg741umdfdwwrgzx684ydwettp/",
      "category": "Adventure",
      "tags": ".io, .io Games, Action, Adventure, Fun, jump, OnlyUp",
      "thumb": "https://img.gamemonetize.com/wjtcbugg741umdfdwwrgzx684ydwettp/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32466",
      "title": "Cool Man Adventure",
      "description": "Hi there! It sounds like youre interested in playing Cool Man Adventure, To play, youll need to jump &amp;amp; run on platforms, avoid obstacles and fire gas , robo, gear ring , and defeat enemies. Dont forget to collect key along the way! The game has 10 levels for you to explore, so theres plenty of adventure to be had.",
      "instructions": "To control your character you can use the arrow keys on your keyboard Alternatively if youre playing on a mobile device you can tap the game screen icons to move your character around ",
      "url": "https://html5.gamemonetize.com/l97eqobidhids1gdhpa2tnc2qr49azof/",
      "category": "Adventure",
      "tags": "1 Player, Adventure, amazing, Arcade, Best Games, html5 games, Kids",
      "thumb": "https://img.gamemonetize.com/l97eqobidhids1gdhpa2tnc2qr49azof/512x384.jpg",
      "width": "1920",
      "height": "1080"
    },
    {
      "id": "32465",
      "title": "Savage Jon  ",
      "description": "Savage Jon is an action-adventure platform game, where Jon looks for adventure and flight monsters, and uses Jet Pack to survive the deadly forest and return home. The mission is to guide Jon through ten levels, collecting trophies in the hideout of his enemy. Are you ready for the action-packed adventure?",
      "instructions": "Use W A S D or Arrow Keys To Move Use Space to Jump Use Ctrl To Fire Use Alt to use JetPack",
      "url": "https://html5.gamemonetize.com/30ck5xaezqv5vuzftf3g1oo4rtk9o9hf/",
      "category": "Adventure",
      "tags": "1 Player, 2D, Adventure, Fun, Mario, Platform",
      "thumb": "https://img.gamemonetize.com/30ck5xaezqv5vuzftf3g1oo4rtk9o9hf/512x384.jpg",
      "width": "960",
      "height": "600"
    },
    {
      "id": "32464",
      "title": "Halloween Tic Tac Toe",
      "description": "Halloween Tic Tac Toe brings a spooky twist to the classic game! Play against a friend or the computer, using ghosts, pumpkins, and other Halloween-themed icons as your Xs and Os. Enjoy the eerie fun and test your strategic skills in this ghoulish version of Tic Tac Toe. Perfect for some quick and spooky entertainment!",
      "instructions": "Mouse click or tap to play",
      "url": "https://html5.gamemonetize.com/bkzm2igk4gc4eyhfy7jst84vjmbnrhwr/",
      "category": "Adventure",
      "tags": "",
      "thumb": "https://img.gamemonetize.com/bkzm2igk4gc4eyhfy7jst84vjmbnrhwr/512x384.jpg",
      "width": "854",
      "height": "560"
    },
    {
      "id": "32379",
      "title": "Steve SurvivalCraft Easy",
      "description": "In this adventure, Steve mounts his horse and wants to go to the villagers. The villagers are waiting for him to show him the chest they found. Steve must collect all the gold, defeat all the monsters in the forest, and reach the chest. When he opens the chest, he will become the king of the entire world. The chest contains a very valuable item. Steve must be very careful, as the forest is filled with monsters and obstacles.",
      "instructions": "Use the WASD keys to move Press the P key to attack with the sword and throw the sword Mobile controls are available for playing on mobile Double jump is active in the game You can jump twice ",
      "url": "https://html5.gamemonetize.com/5tuf1dnz1lq475pw7jyq3s70jq11u8u2/",
      "category": "Adventure",
      "tags": "1 Player, 2D, Adventure, Arcade, Minecraft, Monster, Pixel, Platform",
      "thumb": "https://img.gamemonetize.com/5tuf1dnz1lq475pw7jyq3s70jq11u8u2/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32268",
      "title": "The Wizard Elion : Halloween Edition ",
      "description": "Although you may have lived this little adventure, you will live it again but in a different climate! Take the wizard Elion back home ------------------- Updates to some arts and optimization of scenarios. available languages: English Portuguese Italian",
      "instructions": "Use WASD to move or use the touch screen ",
      "url": "https://html5.gamemonetize.com/se6clex6m0cn5hqdj7j0rvz8ykt91mb5/",
      "category": "Adventure",
      "tags": "1 Player, 2D, Action, Adventure, Best Games, Escape, Funny, Magic",
      "thumb": "https://img.gamemonetize.com/se6clex6m0cn5hqdj7j0rvz8ykt91mb5/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32260",
      "title": "SpaceShip Fight",
      "description": "Space Ship by gamed Fight is an action-packed mobile game that thrusts you into intense space battles. As the pilot of a powerful spacecraft,",
      "instructions": "for mobile use the touch for pc use the mouse",
      "url": "https://html5.gamemonetize.com/dt74ld31xepn9c89z6wa2pi7jkxt4lb8/",
      "category": "Adventure",
      "tags": "Action, Adventure, Fight, Space, Spaceship",
      "thumb": "https://img.gamemonetize.com/dt74ld31xepn9c89z6wa2pi7jkxt4lb8/512x384.jpg",
      "width": "1920",
      "height": "1080"
    },
    {
      "id": "32253",
      "title": "Escape Mystic Castle Mobile version ",
      "description": "A villager was taken to a castle and was trapped there, now try to get out of there if you can! Of course you will have to look for a way out so look carefully and use the items wisely! Its a short adventure, but I think youll like it... #metroidvania #studiosagbr",
      "instructions": "Use the touch controls on the screen to play at the beginning you will see Two squares left side representing the buttons left and right for movement And a square right side representing the jump button ",
      "url": "https://html5.gamemonetize.com/dpei1y1bfdd6vsgthkjwfnk7u7g0xu4s/",
      "category": "Adventure",
      "tags": "1 Player, 2D, Action, Adventure, Best, Bomb, Castle, Classic, Escape, Fantasy, Jigsaw, touchscreen, Warrior",
      "thumb": "https://img.gamemonetize.com/dpei1y1bfdd6vsgthkjwfnk7u7g0xu4s/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32252",
      "title": "The wizard Elion",
      "description": "When the old wizard Elion tried to conjure a sphere of light, a mistake transported him to a modern shopping mall full of monsters. Now, lost among shop windows and strange creatures, Elion needs to find a way to correct his spell and return to his kingdom, before the chaos spreads further and the monsters are completely released. ---------The game has 3 languages: Portuguese, English and Italian ---------You can play on your mobile device too. Good fun!",
      "instructions": "Use WASD to move and MOUSE to interact on the menu title screen If you use the mobile device simply TOUCH the buttons on the SCREEN with your finger and use the ARROW KEYS on the screen to move ",
      "url": "https://html5.gamemonetize.com/473hhqxielr67bfqa3w8e2isxy76yeyv/",
      "category": "Adventure",
      "tags": "1 Player, 2D, Action, Adventure, Best, Best Games, Castle, Escape, Funny, html5 games, Magic, Mobile, Monster, RPG",
      "thumb": "https://img.gamemonetize.com/473hhqxielr67bfqa3w8e2isxy76yeyv/512x384.jpg",
      "width": "1280",
      "height": "720"
    },
    {
      "id": "32224",
      "title": "Major Sparkle",
      "description": "Shoot the historic monster with a fighter plane Explore the world of the historic war between monsters. Players need to destroy all of them and score as high as possible. During fighting don&amp;rsquo;t forget to collect ammos, bombs, and rewards. Be careful! Avoid collision with the monsters or structure either the game will be over. If you like genres such as adventure, action, quests or just want to have a good time then this game is for you. Features of this game: High Quality graphics Game size is minimal Super simple controls Interesting quests",
      "instructions": "How to play Android Use On-Screen touch buttons to control and shoot PC Move Left - Press ldquo Left Arrow rdquo Move Right - Press ldquo Right Arrow rdquo Move Up - Press ldquo Up Arrow rdquo Move Down - Press ldquo Down Arrow rdquo Change Wea",
      "url": "https://html5.gamemonetize.com/vzzbqleb1wwkm5gflrxzkq32sfi7v5ou/",
      "category": "Adventure",
      "tags": "2D, Action, Adventure, Casual, Platform",
      "thumb": "https://img.gamemonetize.com/vzzbqleb1wwkm5gflrxzkq32sfi7v5ou/512x384.jpg",
      "width": "1920",
      "height": "1080"
    },
    {
      "id": "32193",
      "title": "Archer Super Hero",
      "description": "action game, where the archer must cross the monster valley, where he encounters many challenges. Collect all the stars in each stage. Archer Hero is a super fun and challenging 2D side-scroller game in the same style as blockbuster games like Super Mario, Donkey Kong and Sonic. The game features 30 levels that will challenge you to beat it. The designs are very colorful and beautiful!",
      "instructions": "Run Right Key D Run Left Key A Attack Key K Jump Key W ",
      "url": "https://html5.gamemonetize.com/2ftxsmhh3aamnm4tjoylww9yehfyv8jk/",
      "category": "Adventure",
      "tags": "1 Player, Action, attack",
      "thumb": "https://img.gamemonetize.com/2ftxsmhh3aamnm4tjoylww9yehfyv8jk/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32783",
      "title": "Holiday Hex Sort",
      "description": "In Holiday Hex Sort, drag and drop hex tile stacks onto the board. Merge tiles to form stacks of 10 and collect them. As levels progress, more tile types appear. If there are 10 similar tiles on a stack, they will be collected. Clear all tiles by making stacks of 10 before time runs out !",
      "instructions": "Use your mouse or touchpad to drag and drop hex tile stacks onto the board Merge tiles to create stacks of 10 and clear them Complete the board before time runs out ",
      "url": "https://html5.gamemonetize.com/twq47apmwo98gqxz06j4ayvycngyijdy/",
      "category": "Puzzles",
      "tags": "Christmas, hex, Holiday, Matching, Puzzle, sort, sorting",
      "thumb": "https://img.gamemonetize.com/twq47apmwo98gqxz06j4ayvycngyijdy/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32781",
      "title": "Christmas Tic Tac Toe",
      "description": "Christmas Tic Tac Toe is a festive twist on the classic game that brings the holiday spirit to life. Play against friends or challenge yourself in single-player mode as you compete to line up snowmen and Christmas trees instead of the traditional Xs and Os. The game features vibrant holiday graphics with frosty designs, cheerful characters, and falling snowflakes that create a magical winter atmosphere. With quick rounds and easy-to-learn gameplay, its perfect for short bursts of fun or competitive challenges. Track your scores to see who becomes the ultimate Christmas Tic Tac Toe champion.",
      "instructions": "Desktop you can play Christmas Tic Tac Toe using your mouse Simply click on the grid cell where you want to place your symbol either a snowman or a Christmas tree Mobile The game is just as easy to play Use your finger to tap on the grid cell whe",
      "url": "https://html5.gamemonetize.com/hk5qyxw04dzhp7hasacv3tji0a9ww4zb/",
      "category": "Puzzles",
      "tags": "Board, Casual, Hypercasual, Puzzle, Strategy",
      "thumb": "https://img.gamemonetize.com/hk5qyxw04dzhp7hasacv3tji0a9ww4zb/512x384.jpg",
      "width": "720",
      "height": "1280"
    },
    {
      "id": "32778",
      "title": "Christmas Gift Unlock",
      "description": "Dive into the festive spirit with the delightful Christmas Gift Unlock Game! Slide and strategize your way through challenging puzzles to unlock the ultimate Christmas present. This game features vibrant holiday-themed graphics, a cheerful soundtrack, and progressively challenging levels that keep players engaged. Perfect for the holiday season, this brain-teasing game combines fun and mental exercise. Players can enjoy smooth gameplay with intuitive controls and an immersive Christmas environment. Whether you&amp;rsquo;re solving puzzles to pass the time or aiming for a high score, Christmas Gift Unlock Game is the perfect holiday treat for players o",
      "instructions": "On Desktop Use your mouse left button to click and hold on the red blocks Drag the blocks horizontally or vertically to clear the path for the gift box Your goal is to slide the gift box out of the puzzle grid by strategically moving the blocks On Mob",
      "url": "https://html5.gamemonetize.com/l3qu58sxna0pqizngsxs8c6m261s2u8o/",
      "category": "Puzzles",
      "tags": "2D, Adventure, Arcade, Best Games, Block, Christmas, NapTech Games, Puzzle, puzzleblock",
      "thumb": "https://img.gamemonetize.com/l3qu58sxna0pqizngsxs8c6m261s2u8o/512x384.jpg",
      "width": "1080",
      "height": "1920"
    },
    {
      "id": "32773",
      "title": "Gomoku: five stones in a row",
      "description": "Gomoku: Five Stones in a Row is a board logic game for two players. On a square board measuring 19x19 (in the traditional version) or 15x15 (in the modern sports version) points, players alternately place stones of two colors. The winner is the one who is the first to build a continuous row of five stones of his color vertically, horizontally or diagonally. It has many options, differing in individual details of the rules. The game is believed to have been invented in China more than two thousand years ago. Currently, the game is known all over the world; sporting competitions are held based on it.",
      "instructions": "Mouse click or tap to play",
      "url": "https://html5.gamemonetize.com/slrxe38x6845ol68bkcrtet7yqe728g9/",
      "category": "Puzzles",
      "tags": "Board",
      "thumb": "https://img.gamemonetize.com/slrxe38x6845ol68bkcrtet7yqe728g9/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32772",
      "title": "Speed Math",
      "description": "Dive into the exciting world of Speed Math, a brain-teasing puzzle game designed to make math thrilling and improve your calculation skills. Perfect for kids and math lovers of all ages, this game combines education with entertainment for an experience you won&amp;rsquo;t forget! Here&amp;rsquo;s the challenge: At the top of the screen, you&amp;rsquo;ll see a &amp;ldquo;?&amp;rdquo; symbol &amp;ndash; your mission is to fill in the blank with the correct number or operator from the provided options. Think fast, because time is ticking! Each equation or puzzle you solve will put your mental math and problem-solving skills to the ultimate test. Are you ready to master the numbers?",
      "instructions": "Mouse click or tap to play",
      "url": "https://html5.gamemonetize.com/mo4dmfvsrwe2ra49uit0eifv3sxn459c/",
      "category": "Puzzles",
      "tags": "2D, Brain, Click, Educational, Fun, Games, Kids, Math, Mobile, Number, touchscreen",
      "thumb": "https://img.gamemonetize.com/mo4dmfvsrwe2ra49uit0eifv3sxn459c/512x384.jpg",
      "width": "720",
      "height": "1280"
    },
    {
      "id": "32768",
      "title": "Dentist Doctor Game For Kids",
      "description": "Have you ever wanted to be a dentist? Our game can fulfill your desire if you want to be a doctor. In the game, you will play as an oral care doctor who performs different types of dental surgery in a dental clinic. You must perform fillings, cleanings, extractions, stain removal, teeth whitening, and other operations to provide the best oral care for the animals.",
      "instructions": "Mouse click or tap to play ",
      "url": "https://html5.gamemonetize.com/7im5z5sp4512qpsp9x6q0mgp1vbsqz10/",
      "category": "Puzzles",
      "tags": "Animal, Doctor",
      "thumb": "https://img.gamemonetize.com/7im5z5sp4512qpsp9x6q0mgp1vbsqz10/512x384.jpg",
      "width": "1080",
      "height": "1920"
    },
    {
      "id": "32764",
      "title": "Cute Christmas Animals Jigsaw",
      "description": "Cute Christmas Animals Jigsaw is a fun and festive puzzle game designed for kids! It features three adorable animals dressed in cheerful Christmas costumes: a raccoon in a Santa hat, a bunny with a holiday scarf, and a squirrel holding a gift. Kids can choose from three colorful puzzles, improving their problem-solving skills and hand-eye coordination as they play. The game offers simple controls for young players, vibrant illustrations, and a cheerful holiday soundtrack to set the perfect Christmas mood.",
      "instructions": "use mouse or touch the screen",
      "url": "https://html5.gamemonetize.com/wlw4fy6yuuazzvblnru0uupy7ekhfij4/",
      "category": "Puzzles",
      "tags": "Cartoon, Jigsaw",
      "thumb": "https://img.gamemonetize.com/wlw4fy6yuuazzvblnru0uupy7ekhfij4/512x384.jpg",
      "width": "900",
      "height": "600"
    },
    {
      "id": "32760",
      "title": "Sprunki Incredibox Memory",
      "description": "This time in the game Sprunki Incredibox Memory you will need to improve your memory. Cards with the image of Sprunki will appear on the playing field. Each character has a double. Remember the location of the heroes. After a few seconds, the cards will turn towards you with the side that will be the same for everyone. You must click on the cards to find paired Sprunks. Please note that you have a limited number of steps, you will find their limit at the top in Sprunki Incredibox Memory.",
      "instructions": "Mouse click or tap to play",
      "url": "https://html5.gamemonetize.com/fnp0ngnsuu5x0bh4lnve42hwx4vc3wcm/",
      "category": "Puzzles",
      "tags": "Fun, Funny, Kids, Memory, Music, Skill",
      "thumb": "https://img.gamemonetize.com/fnp0ngnsuu5x0bh4lnve42hwx4vc3wcm/512x384.jpg",
      "width": "1920",
      "height": "1080"
    },
    {
      "id": "32758",
      "title": "Scroll and Spot",
      "description": "Experience the joy of the holidays with Scroll and Spot, a unique Christmas-themed puzzle game! Explore two beautifully crafted images as you scroll to uncover five subtle differences hidden within.The scrolling feature keeps both images perfectly aligned, making it a dynamic and immersive puzzle experience. Challenge your observation skills and celebrate the holiday spirit with every discovery!",
      "instructions": "Drag the screen to scroll tap to spot the differences and find all 5 differences to advance to the next level ",
      "url": "https://html5.gamemonetize.com/8jxfjtyj3zka0yqz6i8qvr04lmcg8hb8/",
      "category": "Puzzles",
      "tags": "Christmas, Clicker, Difference, Holiday, Puzzle, Side Scrolling",
      "thumb": "https://img.gamemonetize.com/8jxfjtyj3zka0yqz6i8qvr04lmcg8hb8/512x384.jpg",
      "width": "600",
      "height": "800"
    },
    {
      "id": "32757",
      "title": "Colorful Assort Game",
      "description": "Colorful Assort is a fun and vibrant puzzle game where you match and sort colorful balls. Test your strategy skills as you tackle various levels and challenges. Perfect for a quick and relaxing brain teaser!",
      "instructions": "Mouse click or tap to play",
      "url": "https://html5.gamemonetize.com/92rgvlnfyvms2w91puiip5hr27x4y3uj/",
      "category": "Puzzles",
      "tags": "Brain, Casual, Matching, Strategy",
      "thumb": "https://img.gamemonetize.com/92rgvlnfyvms2w91puiip5hr27x4y3uj/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32752",
      "title": "Hoop KIngs",
      "description": "Hoop Kings is a casual puzzle game where players aim to score points by solving basketball-themed challenges. With engaging gameplay, vibrant graphics, and a mix of strategy and fun, it&amp;rsquo;s perfect for quick entertainment or longer play sessions.",
      "instructions": "How to play Keyboard Use the arrow keys to swipe the ball left right up or down Touch Screen Swipe left right up or down to control the basketballs movement ",
      "url": "https://html5.gamemonetize.com/8gjrfuo4objslb0okt96n8qo41flqrpj/",
      "category": "Puzzles",
      "tags": "Arcade, Basketball, Puzzle",
      "thumb": "https://img.gamemonetize.com/8gjrfuo4objslb0okt96n8qo41flqrpj/512x384.jpg",
      "width": "4600",
      "height": "2000"
    },
    {
      "id": "32751",
      "title": "Connect the Images",
      "description": "In Connect Image, players are challenged to complete fragmented pictures by matching pieces to their corresponding shaded outlines. The objective is simple but engaging: arrange various parts of an image onto the shaded areas, gradually revealing the full picture as you progress. Each puzzle features distinct sections that need to be carefully connected, testing both your visual perception and problem-solving skills. As you place the image parts in the right spots, the incomplete image slowly transforms into a complete and vivid picture, offering a satisfying sense of accomplishment. The difficulty increases with each level, introducing more complex images and intricate pieces, providing a fun and rewarding experience for players of all skill levels. Whether youre looking to relax or challenge your mind, Connect Image offers an addictive puzzle experience that will keep you hooked for hours!",
      "instructions": "Slide the images at the right position to play this game ",
      "url": "https://html5.gamemonetize.com/wigmwb0qrjycip6o6p7of5984t77ydql/",
      "category": "Puzzles",
      "tags": "Kids, Matching, Puzzle",
      "thumb": "https://img.gamemonetize.com/wigmwb0qrjycip6o6p7of5984t77ydql/512x384.jpg",
      "width": "720",
      "height": "1280"
    },
    {
      "id": "32750",
      "title": "Checkmate Clash",
      "description": "Checkmate Clash is the ultimate online chess experience where strategy meets competition! Outsmart opponent in thrilling matches and show off your tactical brilliance. Whether youre a chess master or a beginner, this game offers exciting challenges to sharpen your skills. Plan your moves, dominate the board, and deliver the perfect checkmate. Are you ready to claim victory? The battle for the crown begins now!",
      "instructions": "Mouse to play ",
      "url": "https://html5.gamemonetize.com/0e8bl4kywmf7kikoysg3y06o0ymk0gi2/",
      "category": "Puzzles",
      "tags": "Arcade, Board, Boys, Brain, Classic, Hypercasual, School, Skill",
      "thumb": "https://img.gamemonetize.com/0e8bl4kywmf7kikoysg3y06o0ymk0gi2/512x384.jpg",
      "width": "468",
      "height": "1366"
    },
    {
      "id": "32746",
      "title": "Sprunki Find The Differences",
      "description": "Inspired by the charming world of Sprunki, this game takes your observation skills to the next level. Dive into beautifully crafted scenes filled with vibrant details, where your task is to spot the differences between two seemingly identical images. Whether youre a fan of Sprunki or just love a good brain teaser, Sprunki Find The Differences offers a perfect mix of challenge and fun for players of all ages. Sharpen your focus, enjoy delightful visuals, and immerse yourself in a game thats as engaging as it is entertaining. Start your difference-finding adventure today and prove youre the ultimate spot-the-difference champion!",
      "instructions": "Mouse",
      "url": "https://html5.gamemonetize.com/bs7j4sn0t3lqi1y301b9j76so4x5080h/",
      "category": "Puzzles",
      "tags": "Boys, Difference, Educational, Girls, Hidden, Hypercasual, Puzzle, School, Sprunki",
      "thumb": "https://img.gamemonetize.com/bs7j4sn0t3lqi1y301b9j76so4x5080h/512x384.jpg",
      "width": "1920",
      "height": "1080"
    },
    {
      "id": "32745",
      "title": "Digital Circus Find The Differences",
      "description": "Step into the whimsical and wacky world of Amazing Digital Circus: Find The Differences, where fun meets challenge! Explore vibrant and surreal circus scenes filled with unique characters and zany details, all while sharpening your observation skills. Can you spot the subtle changes between two seemingly identical pictures? Features: Stunning and imaginative circus-themed visuals. A variety of levels, from easy to mind-bendingly tricky. Helpful hints for those tough-to-spot differences. A fun and relaxing experience for all ages. Immerse yourself in the quirky charm of the Amazing Digital Circus.",
      "instructions": "Mouse click",
      "url": "https://html5.gamemonetize.com/ywgj9hhauky1dwqqquy5q37tldkfps8p/",
      "category": "Puzzles",
      "tags": "Boy, Difference, digital circus, Educational, Girls, Hidden, Puzzle, School",
      "thumb": "https://img.gamemonetize.com/ywgj9hhauky1dwqqquy5q37tldkfps8p/512x384.jpg",
      "width": "1920",
      "height": "1080"
    },
    {
      "id": "32743",
      "title": "Dynamic Jigsaw",
      "description": "Pick the pieces and drop it on the correct positions to complete the Puzzle. You can also upload your own image from local storage and play it as a puzzle!",
      "instructions": "Drag and drop the puzzle pieces using mouse click",
      "url": "https://html5.gamemonetize.com/s77lfr8k7qr0hc1ip6k3xznlj82p8n02/",
      "category": "Puzzles",
      "tags": "1 Player, 2D, Puzzle",
      "thumb": "https://img.gamemonetize.com/s77lfr8k7qr0hc1ip6k3xznlj82p8n02/512x384.jpg",
      "width": "960",
      "height": "600"
    },
    {
      "id": "32741",
      "title": "Truefalse",
      "description": "Truefalse players are presented with a series of statements or scenarios, and their task is to discern whether each one is true or false. The catch? The game dynamically generates these statements, mixing truths and falsehoods seamlessly to challenge players perception and intuition.",
      "instructions": "Click with your mouse",
      "url": "https://html5.gamemonetize.com/suleu3k047wd4uxeaxrhirot4az9l48n/",
      "category": "Puzzles",
      "tags": "1 Player, Adventure, amazing, Best, endless, Memory",
      "thumb": "https://img.gamemonetize.com/suleu3k047wd4uxeaxrhirot4az9l48n/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32736",
      "title": "Poler Match",
      "description": "Poler Match is an electrifying puzzle game that challenges players to connect circuits and light up bulbs using limited moves. Set in a futuristic neon world, players must strategically connect energy sources to light up all the bulbs on each level. With increasingly complex puzzles, Poler Match offers hours of brain-teasing fun, testing your logic and problem-solving skills.",
      "instructions": "Objective Connect all the Ns and Ss Controls Tap and drag to connect the Ns and Ss Ensure all Ns are connected before running out of moves ",
      "url": "https://html5.gamemonetize.com/qbt2cmlqn6ia2t1dss5tm6kuzpfq7ovi/",
      "category": "Puzzles",
      "tags": "1 Player, 2048, 2D, Android, Best, Best Games, Puzzle, puzzleblock, Strategy",
      "thumb": "https://img.gamemonetize.com/qbt2cmlqn6ia2t1dss5tm6kuzpfq7ovi/512x384.jpg",
      "width": "1920",
      "height": "1080"
    },
    {
      "id": "32735",
      "title": "Fashion Battle for Survival",
      "description": "In this puzzle game you have to test your memory by guessing the cards in pairs. Each correctly guessed pair brings you closer to winning the game round. And each successfully completed round opens the doors to the world of fashion, allowing you to dress up the main character of the game - an Asian beauty with a daring character. Collect a complete collection of hairstyles and clothing items for the girl that will emphasize her personality. Remember that the time to complete the round is limited by a timer.",
      "instructions": "Depending on the gaming device a computer mouse click or a simple touch on touch screens is used to control it ",
      "url": "https://html5.gamemonetize.com/dhr00x5lotec0haavfstc5gmy8p1b6ue/",
      "category": "Puzzles",
      "tags": "Celebrity, Dress Up, Fashion, Memory, Puzzle",
      "thumb": "https://img.gamemonetize.com/dhr00x5lotec0haavfstc5gmy8p1b6ue/512x384.jpg",
      "width": "800",
      "height": "600"
    },
    {
      "id": "32734",
      "title": "CANDY DREAM",
      "description": "Welcome to Candy Dream, the ultimate candy matching puzzle adventure! Dive into a world filled with delicious candies and embark on a sweet journey through various levels packed with fun and challenging puzzles. Match and collect different candies to progress through levels, achieve high scores, and unlock special power-ups. With its vibrant graphics and engaging gameplay, Candy Dream is perfect for players of all ages who love a sweet challenge.",
      "instructions": "How to Play Match 3 Candies Swap adjacent candies to match three or more of the same kind in a row or column Complete Objectives Each level has specific objectives such as reaching a certain score collecting particular candies or clearing obstacles ",
      "url": "https://html5.gamemonetize.com/i2u9l4ki42txwifuy15pfy71w2vji3s6/",
      "category": "Puzzles",
      "tags": "1 Player, 2D, Candy, Puzzle, puzzleblock",
      "thumb": "https://img.gamemonetize.com/i2u9l4ki42txwifuy15pfy71w2vji3s6/512x384.jpg",
      "width": "960",
      "height": "540"
    },
    {
      "id": "32730",
      "title": "SpongeBob Find The Differences",
      "description": "Dive into the underwater fun with Sponge Find The Differences, a thrilling puzzle game inspired by the lovable world of SpongeBob! Challenge your observation skills as you explore 30 exciting levels filled with colorful and quirky scenes. Can you spot all the differences between two seemingly identical images before time runs out? 30 Levels of engaging find the difference puzzles. Timed Challenges to test your focus and speed. Vibrant visuals inspired by underwater adventures. Suitable for all ages &amp;ndash; fun for the whole family!",
      "instructions": "Mouse ",
      "url": "https://html5.gamemonetize.com/fvzr892y3w3n3sa4p98dbwdw08lht8m6/",
      "category": "Puzzles",
      "tags": "Boys, Educational, Girls, Hidden, Puzzle, School, Spongebob",
      "thumb": "https://img.gamemonetize.com/fvzr892y3w3n3sa4p98dbwdw08lht8m6/512x384.jpg",
      "width": "1920",
      "height": "1080"
    }
   
  ]
